// this page for selling products
import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEnhancedFetch } from '../hooks/useRequestManager';
import { Modal, Button, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AddCustomer1Modal from '../components/AddCustomer1Modal';
import AddCustomer2Modal from '../components/AddCustomer2Modal';
import AddCustomer3Modal from '../components/AddCustomer3Modal';
import Customer3SalesHistoryModal from '../components/Customer3SalesHistoryModal';
import Customer2ManagementModal from '../components/Customer2ManagementModal';
import Customer2SaleModal from '../components/Customer2SaleModal';
import { FaTrash, FaBox, FaShoppingCart, FaTruck, FaImage, FaRegImage, FaEdit } from 'react-icons/fa';
import SaleConfirmationModal from '../components/SaleConfirmationModal';
import MultiplePaymentModal from '../components/MultiplePaymentModal';
import PaymentMethodSelector from '../components/PaymentMethodSelector';
import { useExchangeRate } from '../ExchangeRateContext';
import StoreSelect from '../components/StoreSelect';
import { useAuth } from '../contexts/AuthContext';
import printing from '../services/printing';


const paymentTypes = [
  { value: 'cash', label: "Naqd pul" },
  { value: 'terminal', label: "Terminal" },
  { value: 'card', label: "Karta" },
  { value: 'hybrid', label: 'Gibrid  ' }
];

// Helper function to format date from ISO string to DD-MM-YYYY, HH-MM format
const formatDate = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-indexed
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year}, ${hours}:${minutes}`;
};

const initialCustomer = (id) => ({
  id,
  cart: [],
  paymentType: '',
  name: '',
  delivery: false
});

const Kassa = () => {
  const { token, user } = useAuth();
  const { rate: exchangeRate } = useExchangeRate(); // Destructure to get the rate property
  // 1. Close sidebar on mount
  useEffect(() => {
    // Try to find sidebar and collapse it if possible
    const sidebar = document.querySelector('.sidebar');
    if (sidebar && !sidebar.classList.contains('collapsed')) {
      const btn = sidebar.querySelector('button');
      if (btn) btn.click();
    }
  }, []);
  const [customers, setCustomers] = useState([initialCustomer(1), initialCustomer(2)]);
  const [activeCustomer, setActiveCustomer] = useState(1);
  const [categoryTab, setCategoryTab] = useState('Mahsulotlar');
  const [search, setSearch] = useState('');
  const [barcode, setBarcode] = useState('');
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchProduct, setBatchProduct] = useState(null);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [batchQty, setBatchQty] = useState(1);
  // State for multiple batch selection (Specific products only)
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [saleStatus, setSaleStatus] = useState(null);
  const [productQuantities, setProductQuantities] = useState({});
  const [loadingQuantities, setLoadingQuantities] = useState({});
  // Track quantities per batch (batch_id -> quantity)
  const [batchQuantities, setBatchQuantities] = useState({});
  // Add new state for modal type and batch/barcode data
  const [modalType, setModalType] = useState(null); // 'FIFO' or 'Specific'
  const [fifoBatches, setFifoBatches] = useState([]);
  const [specificBarcodesByBatch, setSpecificBarcodesByBatch] = useState({});
  const [loadingModal, setLoadingModal] = useState(false);
  const [modalError, setModalError] = useState('');
  // Add barcode search state for Specific modal
  const [specificBarcodeSearch, setSpecificBarcodeSearch] = useState('');
  // State for selected category
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  // State for barcode search in product list
  const [barcodeSearch, setBarcodeSearch] = useState('');
  const [barcodeInput, setBarcodeInput] = useState('');
  // State for caching all barcodes (both FIFO and Specific)
  const [allBarcodes, setAllBarcodes] = useState([]);
  const [barcodesLoading, setBarcodesLoading] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerSearch, setCustomerSearch] = useState('');
  const [showCustomer2Modal, setShowCustomer2Modal] = useState(false);
  const [showCustomer2ManagementModal, setShowCustomer2ManagementModal] = useState(false);
  const [showCustomer3Modal, setShowCustomer3Modal] = useState(false);
  // Customer3 states
  const [allCustomer3s, setAllCustomer3s] = useState([]);
  const [selectedCustomer3, setSelectedCustomer3] = useState(null);
  const [showCustomer3SalesModal, setShowCustomer3SalesModal] = useState(false);
  const [loadingCustomer3s, setLoadingCustomer3s] = useState(false);
  // Customer2 states
  const [customer2Search, setCustomer2Search] = useState('');
  const [allCustomer2s, setAllCustomer2s] = useState([]);
  const [selectedCustomer2, setSelectedCustomer2] = useState(null);
  const [loadingCustomer2s, setLoadingCustomer2s] = useState(false);
  const [showCustomer2SaleModal, setShowCustomer2SaleModal] = useState(false);
  // Add delivery price state at the top
  const [deliveryPrice, setDeliveryPrice] = useState('');
  const [showSaleConfirmModal, setShowSaleConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showMultiplePaymentModal, setShowMultiplePaymentModal] = useState(false);
  const [isFirstPrice, setIsFirstPrice] = useState(false);
  const [hybridPayments, setHybridPayments] = useState([]);
  // Store filter state
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [stores, setStores] = useState([]);
  const [printAfterSale, setPrintAfterSale] = useState(false);
  const [showImages, setShowImages] = useState(() => {
    const saved = localStorage.getItem('kassa_show_images');
    return saved !== null ? JSON.parse(saved) : true;
  });
  // Booking state
  const [bookingId, setBookingId] = useState(null);
  const [isBookingSale, setIsBookingSale] = useState(false);
  // In booking-sale mode, we must exclude this booking from "booked" subtraction
  // so the booked items become sellable.
  const bookingExcludeQuery = useMemo(() => {
    return bookingId ? `&excludeBookingId=${encodeURIComponent(String(bookingId))}` : '';
  }, [bookingId]);

  useEffect(() => {
    localStorage.setItem('kassa_show_images', JSON.stringify(showImages));
  }, [showImages]);

  // Load booking data from localStorage on mount
  useEffect(() => {
    const bookingDataStr = localStorage.getItem('bookingData');
    if (bookingDataStr) {
      try {
        const bookingData = JSON.parse(bookingDataStr);
        if (bookingData.bookingId && bookingData.items && bookingData.items.length > 0) {
          const incomingBookingId = bookingData.bookingId;
          setBookingId(incomingBookingId);
          setIsBookingSale(true);

          // Load items into cart and update batch quantities
          const loadBookingItems = async () => {
            const updatedItems = [];
            const batchQtyUpdates = {};

            for (const item of bookingData.items) {
              if (!item.batch_id) {
                updatedItems.push(item);
                continue;
              }

              // Fetch batch details to get current quantity_remaining
              try {
                const batchRes = await fetch(`/api/purchases/batch/${item.batch_id}`, {
                  headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                  }
                });

                if (batchRes.ok) {
                  const batch = await batchRes.json();
                  const currentQty = Number(batch.quantity_remaining || 0);
                  const bookedQty = Number(item.qty || 0);

                  // Calculate remaining quantity for this batch
                  const remainingQty = Math.max(0, currentQty - bookedQty);

                  // Store batch quantity update
                  batchQtyUpdates[item.batch_id] = remainingQty;
                }
              } catch (e) {
                console.error('Error fetching batch quantity for booking item:', e);
              }

              updatedItems.push(item);
            }

            // Update batch quantities
            setBatchQuantities(prev => ({
              ...prev,
              ...batchQtyUpdates
            }));

            // Update product quantities (sum of all batch quantities per product)
            const productQtyUpdates = {};
            const processedProducts = new Set();

            for (const item of updatedItems) {
              const productId = item.id || item.productid;
              if (!productId) continue;

              const cacheKey = `${productId}_${selectedStoreId}`;
              if (!processedProducts.has(cacheKey)) {
                processedProducts.add(cacheKey);
                // Fetch SELLABLE batches for this product to calculate total (exclude active bookings, but
                // exclude this booking itself so these items become sellable for booking-sale mode)
                try {
                  const res = await fetch(
                    `/api/products/${productId}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}&excludeBookingId=${encodeURIComponent(String(incomingBookingId))}`,
                    {
                      headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                      }
                    }
                  );

                  if (res.ok) {
                    const batches = await res.json();
                    const product = products.find(p => p.productid === productId || p.id === productId);

                    // Calculate TOTAL sellable quantity from endpoint (already excludes other bookings)
                    let totalQty = 0;
                    batches.forEach(batch => {
                      const batchQty = Number(batch.available_quantity ?? batch.quantity_remaining ?? 0);

                      if (product && product.costing_method === 'Specific') {
                        if ((batch.status || '').toLowerCase() === 'available' && batchQty > 0) {
                          totalQty += batchQty;
                        }
                      } else {
                        if (batchQty > 0) {
                          totalQty += batchQty;
                        }
                      }
                    });

                    productQtyUpdates[cacheKey] = totalQty;
                  }
                } catch (e) {
                  console.error('Error calculating product quantity:', e);
                }
              }
            }

            // Update product quantities
            setProductQuantities(prev => ({
              ...prev,
              ...productQtyUpdates
            }));

            updateCustomer(current.id, {
              cart: updatedItems
            });

            // Set delivery price
            if (bookingData.delivery_price) {
              setDeliveryPrice(String(bookingData.delivery_price));
              updateCustomer(current.id, { delivery: bookingData.delivery_price > 0 });
            }

            // Clear localStorage
            localStorage.removeItem('bookingData');
          };

          loadBookingItems();
        }
      } catch (error) {
        console.error('Error loading booking data:', error);
        localStorage.removeItem('bookingData');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStoreId]);

  // Customer data states - removed automatic fetching
  const [allCustomers, setAllCustomers] = useState([]);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [customersError, setCustomersError] = useState(null);

  // Fetch categories and products only
  const { data: categoryData } = useEnhancedFetch('/api/categories');
  const { data: productData } = useEnhancedFetch('/api/products');

  // Fetch stores and set first store as default
  useEffect(() => {
    if (!token) return;

    const isStaff = user?.role === 'staff';
    const url = isStaff ? '/api/store-permissions/export-stores' : '/api/stores';
    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error('Failed to fetch stores');
        }
        return res.json();
      })
      .then(data => {
        const storesList = Array.isArray(data) ? data : (data?.items || []);
        setStores(storesList);

        // Set first store as default if no store is selected yet
        if (storesList.length > 0 && selectedStoreId === null) {
          const firstStoreId = storesList[0].id || storesList[0].ID;
          setSelectedStoreId(firstStoreId);
        }
      })
      .catch(error => {
        console.error('Error fetching stores:', error);
      });
  }, [token, user, selectedStoreId]);



  const categories = categoryData?.items || [];
  // 2. Fix products.map error: ensure products is always an array
  const baseProducts = Array.isArray(productData?.items) ? productData.items : Array.isArray(productData) ? productData : [];
  // Multi-tenant restriction: staff without export_from stores should not see products
  const products = (user?.role === 'staff' && stores.length === 0) ? [] : baseProducts;

  // Customer data fetching functions
  const fetchCustomer1Data = useCallback(async () => {
    if (loadingCustomers || allCustomers.length > 0) return; // Don't fetch if already loading or has data

    setLoadingCustomers(true);
    setCustomersError(null);

    const abortController = new AbortController();

    try {
      const res = await fetch('/api/customer1', {
        signal: abortController.signal,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();

      if (isMounted.current) {
        setAllCustomers(Array.isArray(data) ? data : []);
        setLoadingCustomers(false);
      }
    } catch (err) {
      if (err.name !== 'AbortError' && isMounted.current) {
        console.error('Error fetching customer1s:', err);
        setCustomersError(err.message);
        setLoadingCustomers(false);
      }
    }

    return () => {
      abortController.abort();
    };
  }, [token, loadingCustomers, allCustomers.length]);

  const fetchCustomer2Data = useCallback(async () => {
    if (loadingCustomer2s || allCustomer2s.length > 0) return; // Don't fetch if already loading or has data

    setLoadingCustomer2s(true);

    const abortController = new AbortController();

    try {
      const res = await fetch('/api/customer2', {
        signal: abortController.signal,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();

      if (isMounted.current) {
        setAllCustomer2s(Array.isArray(data) ? data : []);
        setLoadingCustomer2s(false);
      }
    } catch (err) {
      if (err.name !== 'AbortError' && isMounted.current) {
        console.error('Error fetching customer2s:', err);
        setLoadingCustomer2s(false);
      }
    }

    return () => {
      abortController.abort();
    };
  }, [token, loadingCustomer2s, allCustomer2s.length]);

  const fetchCustomer3Data = useCallback(async () => {
    if (loadingCustomer3s || allCustomer3s.length > 0) return; // Don't fetch if already loading or has data

    setLoadingCustomer3s(true);

    const abortController = new AbortController();

    try {
      const res = await fetch('/api/customer3', {
        signal: abortController.signal,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();

      if (isMounted.current) {
        setAllCustomer3s(Array.isArray(data) ? data : []);
        setLoadingCustomer3s(false);
      }
    } catch (err) {
      if (err.name !== 'AbortError' && isMounted.current) {
        console.error('Error fetching customer3s:', err);
        setLoadingCustomer3s(false);
      }
    }

    return () => {
      abortController.abort();
    };
  }, [token, loadingCustomer3s, allCustomer3s.length]);

  // Handle customer fetch errors
  useEffect(() => {
    if (customersError) {
      toast.error('Mijozlarni yuklashda xatolik: ' + customersError);
    }
  }, [customersError]);

  // 1. Barcode input: add to cart automatically when a match is found
  useEffect(() => {
    if (!barcodeInput || !token || barcodesLoading) return;

    console.log(`Processing barcode input: ${barcodeInput}`);
    console.log(`Available barcodes: ${allBarcodes.length}`, allBarcodes);

    // Find the barcode in our unified list
    const foundBarcode = allBarcodes.find(item =>
      item.barcode && item.barcode.toLowerCase() === barcodeInput.toLowerCase()
    );

    if (foundBarcode) {
      console.log(`Found barcode match:`, foundBarcode);

      if (foundBarcode.type === 'FIFO') {
        // Handle FIFO product per-batch: allocate 1 unit to earliest available batch
        const prod = foundBarcode.product;
        // addFifoProductUnits returns a promise; fire-and-forget here
        addFifoProductUnits(prod, 1);
      } else if (foundBarcode.type === 'Specific') {
        // Handle Specific product
        const prod = foundBarcode.product;
        const batch = foundBarcode.batch;

        // Check if this exact barcode already exists in cart (ignore duplicate)
        const exists = cart.some(item => item.id === prod.productid && item.batch_barcode === foundBarcode.barcode);
        if (exists) {
          console.log(`Barcode ${foundBarcode.barcode} already exists in cart for product ${prod.name}`);
          setBarcodeInput('');
          return;
        }

        // Use the same price calculation logic as product cards
        let basePrice = (batch.sellingprice !== undefined && batch.sellingprice !== null)
          ? Number(batch.sellingprice)
          : prod.price;
        let priceUSD = null;

        if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && isFirstPrice && batch.first_price !== undefined) {
          basePrice = Number(batch.first_price);
        }

        const priceUZS = (batch.currency === 'USD')
          ? (() => {
            if (!exchangeRate || isNaN(exchangeRate) || exchangeRate <= 0) {
              console.error('Invalid exchange rate for specific barcode input:', exchangeRate);
              return basePrice; // Fallback to original price
            }
            return Math.round(basePrice * exchangeRate);
          })()
          : basePrice;

        if (batch.currency === 'USD') {
          priceUSD = basePrice;
        }

        // Add as new row in cart (different barcode = new row for Specific products)
        let cartItem = {
          ...prod,
          id: prod.productid,
          batch_id: batch.id,
          batch_barcode: foundBarcode.barcode,
          qty: 1,
          price: priceUZS,
          name: getProductName(prod)
        };

        // For Customer3 USD, store USD price
        if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
          cartItem.price_usd = priceUSD;
          cartItem.currency_source = 'USD';
        }

        updateCustomer(current.id, {
          cart: [...cart, cartItem]
        });

        console.log(`Added Specific product ${prod.name} with barcode ${foundBarcode.barcode} to cart`);
      }

      setBarcodeInput('');
    } else {
      console.log(`No barcode match found for: ${barcodeInput}`);
    }

    // eslint-disable-next-line
  }, [barcodeInput, token, allBarcodes, barcodesLoading]);

  const addCustomer = () => {
    const newId = customers.length ? Math.max(...customers.map(c => c.id)) + 1 : 1;
    setCustomers([...customers, initialCustomer(newId)]);
    setActiveCustomer(newId);
  };

  const removeCustomer = (id) => {
    const filtered = customers.filter(c => c.id !== id);
    setCustomers(filtered);
    if (filtered.length) setActiveCustomer(filtered[0].id);
  };

  const updateCustomer = useCallback((id, changes) => {
    setCustomers(prevCustomers => prevCustomers.map(c => c.id === id ? { ...c, ...changes } : c));
  }, []);

  const current = useMemo(() => customers.find(c => c.id === activeCustomer), [customers, activeCustomer]);
  const cart = useMemo(() => current ? current.cart : [], [current]);
  const totalQty = useMemo(() => cart.reduce((sum, item) => sum + item.qty, 0), [cart]);

  // Calculate total by currency
  const calculateTotalByCurrency = () => {
    const totals = {};
    cart.forEach(item => {
      const currency = item.currency || 'UZS';
      const amount = item.qty * item.price;
      totals[currency] = (totals[currency] || 0) + amount;
    });
    return totals;
  };

  // Format total display
  const formatTotalDisplay = () => {
    const totals = calculateTotalByCurrency();
    const currencies = Object.keys(totals);

    if (currencies.length === 0) return '0 UZS';
    if (currencies.length === 1) {
      return `${totals[currencies[0]].toLocaleString()} ${currencies[0]}`;
    }

    // Multiple currencies
    return currencies.map(currency =>
      `${totals[currency].toLocaleString()} ${currency}`
    ).join(' + ');
  };

  // 4. Calculate total sum in UZS only
  const totalSum = useMemo(() => cart.reduce((sum, item) => sum + (item.qty * item.price), 0), [cart]);
  const overal = useMemo(() => totalSum + Number(deliveryPrice), [totalSum, deliveryPrice]);

  // Barcode scan/enter logic
  const handleBarcodeEnter = async (e) => {
    if (e.key === 'Enter' && barcode) {
      // Try FIFO product barcode
      const product = products.find(p => p.barcode === barcode);
      if (product) {
        if (product.costing_method === 'Specific') {
          await openBatchModal(product);
        } else {
          // FIFO: allocate 1 unit per-batch using FIFO
          addFifoProductUnits(product, 1);
        }
        setBarcode('');
        return;
      }
      // Try batch barcode for Specific Identification
      for (const prod of products.filter(p => p.costing_method === 'Specific')) {
        if (!prod.productid) continue;
        try {
          const url = selectedStoreId
            ? `/api/products/${prod.productid}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId))}${isBookingSale ? bookingExcludeQuery : ''}`
            : `/api/products/${prod.productid}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`;

          const res = await fetch(url, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (!res.ok) {
            console.error(`Failed to fetch batches for product ${prod.productid}:`, res.status, res.statusText);
            continue;
          }

          const batchList = await res.json();
          const batch = batchList.find(b => b.barcode === barcode);
          if (batch) {
            let price;
            let priceUSD = null;
            if (batch.currency === 'USD') {
              priceUSD = batch.sellingprice;
              price = Math.round(batch.sellingprice * exchangeRate);
            } else {
              price = batch.sellingprice;
            }

            let cartItem = {
              ...prod,
              id: prod.productid,
              batch_id: batch.id,
              batch_barcode: batch.barcode,
              qty: 1,
              price,
              name: getProductName(prod)
            };

            // For Customer3 USD, store USD price
            if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
              cartItem.price_usd = priceUSD;
              cartItem.currency_source = 'USD';
            }

            updateCustomer(current.id, {
              cart: [...cart, cartItem]
            });
            setBarcode('');
            return;
          }
        } catch (err) {
          console.error(`Error processing barcode for product ${prod.productid}:`, err);
        }
      }
      setBarcode('');
    }
  };



  // 2. When opening the modal, pre-select the radio if product/batch is in cart
  const openBatchModal = async (product) => {
    // Always use productid for consistency
    const productId = product.productid;
    if (!productId) {
      console.error('No productid found for product:', product);
      setModalError('Product ID not found');
      return;
    }

    setBatchProduct(product);
    setShowBatchModal(true);
    setSelectedBatch(null);
    setBatchQty(1);
    setSelectedBatches([]); // Reset multiple selection
    setLoadingModal(true);
    setModalError(''); // Clear any previous errors

    // Create abort controller for this modal session
    const abortController = new AbortController();

    try {
      // Fetch batches with cancellation support
      // IMPORTANT: show only sellable batches (exclude active bookings)
      const res = await fetch(
        `/api/products/${productId}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          signal: abortController.signal
        }
      );

      if (!res.ok) {
        throw new Error(`Failed to fetch batches: ${res.status} ${res.statusText}`);
      }

      const batchList = await res.json();

      // Check if modal was closed during fetch
      if (!isMounted.current || abortController.signal.aborted) {
        return;
      }

      if (product.costing_method === 'FIFO') {
        setModalType('FIFO');
        // Filter FIFO batches with sellable quantity > 0 (already excludes bookings)
        const fifoBatches = batchList.filter(b => Number(b.available_quantity || 0) > 0);
        setFifoBatches(fifoBatches);

        // Pre-select batch if in cart
        const cartItem = cart.find(item => item.id === productId && item.batch_id);
        if (cartItem) {
          const foundBatch = fifoBatches.find(b => b.id === cartItem.batch_id);
          if (foundBatch) setSelectedBatch(foundBatch);
        }
      } else if (product.costing_method === 'Specific') {
        setModalType('Specific');

        if (batchList.length === 0) {
          setModalError('Bu mahsulot uchun hech qanday partiya topilmadi');
          return;
        }

        // Specific items are 1-row-per-barcode in `purchase_batches`.
        // Using `available-batches` already excludes booked barcodes, so do NOT refetch from /purchases/batch/:id/barcodes.
        const barcodesByBatch = {};
        batchList.forEach(batch => {
          barcodesByBatch[batch.id] = { batch, barcodes: batch.barcode ? [batch.barcode] : [] };
        });
        setSpecificBarcodesByBatch(barcodesByBatch);

        // Pre-select batch+barcode if in cart
        const cartItem = cart.find(item => item.id === productId && item.batch_id && item.batch_barcode);
        if (cartItem) {
          // Find the batch and barcode
          const batchEntry = Object.values(barcodesByBatch).find(({ batch }) => batch.id === cartItem.batch_id);
          if (batchEntry) {
            setSelectedBatch({ ...batchEntry.batch, barcode: cartItem.batch_barcode });
          }
        }
      } else {
        setModalError('Unknown costing method: ' + product.costing_method);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error in openBatchModal:', error);
        setModalError(`Error loading batches: ${error.message}`);
      }
    } finally {
      if (isMounted.current && !abortController.signal.aborted) {
        setLoadingModal(false);
      }
      abortController.abort(); // Clean up any pending requests
    }
  };

  // Add selected batch to cart
  const handleBatchAdd = () => {
    if (modalType === 'Specific') {
      handleMultipleBatchAdd();
      return;
    }

    if (!selectedBatch || !batchProduct) return;

    // Always use productid for consistency
    const productId = batchProduct.productid;
    if (!productId) {
      setModalError('Product ID not found');
      return;
    }

    // For Specific, prevent duplicate barcode in cart (robust: always use id and batch_barcode)
    if (modalType === 'Specific' && selectedBatch.barcode) {
      const exists = cart.some(item => item.id === productId && item.batch_barcode === selectedBatch.barcode);
      if (exists) {
        setModalError('Bu barcode allaqachon savatda mavjud!');
        return;
      }
    }

    // Determine the correct price for the item
    let itemPrice = 0;
    let itemPriceUSD = null;
    if (modalType === 'Specific') {
      // For Specific products, use batch sellingprice or fallback to product price
      let basePrice = selectedBatch.sellingprice || batchProduct.price || 0;

      // Handle first_price logic for Customer3 USD
      if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && isFirstPrice && selectedBatch.first_price !== undefined) {
        basePrice = selectedBatch.first_price;
      }

      if (selectedBatch.currency === 'USD') {
        itemPriceUSD = basePrice; // Store original USD price
        if (!exchangeRate || isNaN(exchangeRate) || exchangeRate <= 0) {
          console.error('Invalid exchange rate for batch add:', exchangeRate);
          setModalError('Exchange rate error. Please try again.');
          return;
        }
        itemPrice = Math.round(basePrice * exchangeRate); // Convert to UZS
      } else {
        itemPrice = basePrice;
      }
    } else {
      // FIFO: respect selectedBatch from modal; add qty to that specific batch row
      const product = batchProduct;
      const batch = selectedBatch;
      const productId = product.productid;
      // Validate against sellable quantity (exclude bookings already handled by available-batches)
      const usedInCartForBatch = cart
        .filter(ci => ci.id === productId && ci.batch_id === batch.id)
        .reduce((sum, ci) => sum + Number(ci.qty || 0), 0);
      const sellableInBatch = Math.max(0, Number(batch.available_quantity ?? batch.quantity_remaining ?? 0) - usedInCartForBatch);
      if (Number(batchQty) > sellableInBatch) {
        setModalError(`Yetarli mahsulot mavjud emas! Mavjud: ${sellableInBatch.toFixed(3)}, Siz so'ragan: ${Number(batchQty).toFixed(3)}`);
        return;
      }
      const { priceUZS, priceUSD } = computeBatchPrices(batch, product);
      const existingIndex = cart.findIndex(ci => ci.id === productId && ci.batch_id === batch.id);
      let newCart;
      if (existingIndex !== -1) {
        const existing = cart[existingIndex];
        const updated = { ...existing, qty: existing.qty + batchQty };
        if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
          updated.price_usd = priceUSD;
          updated.currency_source = 'USD';
          updated.price = priceUZS;
        } else {
          updated.price = priceUZS;
        }
        newCart = cart.map((ci, i) => i === existingIndex ? updated : ci);
      } else {
        const cartItem = {
          ...product,
          id: productId,
          name: getProductName(product),
          batch_id: batch.id,
          qty: batchQty,
          price: priceUZS
        };
        if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
          cartItem.price_usd = priceUSD;
          cartItem.currency_source = 'USD';
        }
        newCart = [...cart, cartItem];
      }
      updateCustomer(current.id, { cart: newCart });
      setShowBatchModal(false);
      setBatchProduct(null);
      setBatches([]);
      setSelectedBatch(null);
      setBatchQty(1);
      setModalError('');
      return;
    }

    let cartItem = {
      ...batchProduct,
      id: productId,
      batch_id: selectedBatch.id,
      batch_barcode: selectedBatch.barcode,
      qty: batchQty,
      price: itemPrice,
      name: getProductName(batchProduct)
    };

    // For Customer3 USD, store USD price
    if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && itemPriceUSD) {
      cartItem.price_usd = itemPriceUSD;
      cartItem.currency_source = 'USD';
    }

    updateCustomer(current.id, {
      cart: [...cart, cartItem]
    });
    // Only close and reset modal if no error
    setShowBatchModal(false);
    setBatchProduct(null);
    setBatches([]);
    setSelectedBatch(null);
    setBatchQty(1);
    setModalError('');
  };

  // Handle multiple batch selection for Specific products
  const handleMultipleBatchAdd = () => {
    if (!batchProduct || selectedBatches.length === 0) return;

    const productId = batchProduct.productid;
    if (!productId) {
      setModalError('Product ID not found');
      return;
    }

    // Check for duplicate barcodes in cart
    const duplicateBarcodes = selectedBatches.filter(selected => {
      return cart.some(item => item.id === productId && item.batch_barcode === selected.barcode);
    });

    if (duplicateBarcodes.length > 0) {
      setModalError(`Bu barcodelar allaqachon savatda mavjud: ${duplicateBarcodes.map(b => b.barcode).join(', ')}`);
      return;
    }

    // Add all selected batches to cart
    const newCartItems = selectedBatches.map(selected => {
      const batch = selected.batch;

      // Use the same price calculation logic as product cards
      let basePrice = (batch.sellingprice !== undefined && batch.sellingprice !== null)
        ? Number(batch.sellingprice)
        : batchProduct.price;
      let priceUSD = null;

      if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && isFirstPrice && batch.first_price !== undefined) {
        basePrice = Number(batch.first_price);
      }

      const priceUZS = (batch.currency === 'USD')
        ? (() => {
          if (!exchangeRate || isNaN(exchangeRate) || exchangeRate <= 0) {
            console.error('Invalid exchange rate for multiple batch add:', exchangeRate);
            return basePrice; // Fallback to original price
          }
          return Math.round(basePrice * exchangeRate);
        })()
        : basePrice;

      if (batch.currency === 'USD') {
        priceUSD = basePrice;
      }

      let cartItem = {
        ...batchProduct,
        id: productId,
        batch_id: batch.id,
        batch_barcode: selected.barcode,
        qty: 1,
        price: priceUZS,
        name: getProductName(batchProduct)
      };

      // For Customer3 USD, store USD price
      if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
        cartItem.price_usd = priceUSD;
        cartItem.currency_source = 'USD';
      }

      return cartItem;
    });

    updateCustomer(current.id, {
      cart: [...cart, ...newCartItems]
    });

    // Close modal and reset
    setShowBatchModal(false);
    setBatchProduct(null);
    setSelectedBatches([]);
    setModalError('');
  };

  const handleSale = async (shouldPrint = false) => {
    setPrintAfterSale(Boolean(shouldPrint));
    if (!cart.length) return;
    if (current.paymentType === 'hybrid') {
      // If no payments captured yet, open modal first
      if (!Array.isArray(hybridPayments) || hybridPayments.length === 0) {
        setShowMultiplePaymentModal(true);
        return;
      }
      // Validate that total of hybrid payments equals current overal before showing confirm
      const enteredTotal = hybridPayments.reduce((sum, p) => sum + Number(p?.amount || 0), 0);
      if (Math.round(enteredTotal) !== Math.round(overal)) {
        setSaleStatus({ type: 'danger', message: "Gibrid to'lov summalari umumiy summaga teng emas." });
        setShowMultiplePaymentModal(true);
        return;
      }
    }
    // Open confirmation modal for all payment types
    setShowSaleConfirmModal(true);
  };

  const handlePaymentTypeChange = (e) => {
    const value = e.target.value;
    updateCustomer(current.id, { paymentType: value });
    // Open multiple payment modal immediately when hybrid is selected
    if (value === 'hybrid') {
      setShowMultiplePaymentModal(true);
    }
    // Clear previously set hybrid payments when changing away from hybrid
    if (value !== 'hybrid' && hybridPayments.length > 0) {
      setHybridPayments([]);
    }
  };

  const handleBookingSuccess = () => {
    // Clear cart and reset selections; set payment type back to empty
    updateCustomer(current.id, { cart: [], paymentType: '', delivery: false });
    setDeliveryPrice('');
    setSelectedCustomer(null);
    setSelectedCustomer2(null);
    setSelectedCustomer3(null);
    setShowSaleConfirmModal(false);
    setShowMultiplePaymentModal(false);
    setHybridPayments([]);
    // Clear booking state
    setBookingId(null);
    setIsBookingSale(false);
    // Force cards/barcodes to refetch with updated "booked" state
    setProductQuantities({});
    setLoadingQuantities({});
    setBatchQuantities({});
    setAllBarcodes([]);
    setEarliestBatchByProductId({});
    setAllFifoBatchesByProductId({});
  };

  const handleConfirmSale = async (payments = null, shouldPrint = false) => {
    if (isSubmitting) return;

    const isCustomer2 = !!selectedCustomer2;
    const isCustomer3 = !!selectedCustomer3;

    // Validate payment method is selected for Guest/Customer1/Customer3 (Customer2 is credit by default)
    if (!current.paymentType && !isCustomer2 && !isCustomer3) {
      toast.error("To'lov usulini tanlang");
      return;
    }

    setIsSubmitting(true);
    setSaleStatus(null);

    // Create abort controller for this sale operation
    const abortController = new AbortController();

    try {
      const isCustomer2 = !!selectedCustomer2;
      const isCustomer3 = !!selectedCustomer3;
      // Validate hybrid payments at submission time as well
      if (current.paymentType === 'hybrid' && !isCustomer2 && !isCustomer3) {
        const paymentsToUse = (payments && payments.length > 0) ? payments : hybridPayments;
        if (!Array.isArray(paymentsToUse) || paymentsToUse.length === 0) {
          setSaleStatus({ type: 'danger', message: "Gibrid to'lovlar kiritilmagan." });
          setShowMultiplePaymentModal(true);
          setIsSubmitting(false);
          return;
        }
        const enteredTotal = paymentsToUse.reduce((sum, p) => sum + Number(p?.amount || 0), 0);
        if (Math.round(enteredTotal) !== Math.round(overal)) {
          setSaleStatus({ type: 'danger', message: "Gibrid to'lov summalari umumiy summaga teng emas." });
          setShowMultiplePaymentModal(true);
          setIsSubmitting(false);
          return;
        }
      }
      // Determine sale currency for each item
      let saleCurrency = 'UZS';
      if (selectedCustomer3 && selectedCustomer3.currency) {
        saleCurrency = selectedCustomer3.currency;
      }

      const items = cart.map(item => {
        // For customer3, use their currency; for others, always UZS
        let currency = saleCurrency;
        let price = item.price;

        if (!selectedCustomer3) {
          currency = 'UZS';
        } else if (selectedCustomer3.currency === 'USD' && item.price_usd !== undefined) {
          // For Customer3 USD with price_usd, use the USD price directly
          price = item.price_usd;
          currency = 'USD';
        }

        let saleItem = {
          product_id: item.id,
          quantity: item.qty,
          price: price,
          currency: currency
        };

        if (item.batch_id) {
          saleItem.batch_id = item.batch_id;
          saleItem.batch_barcode = item.batch_barcode;
        }

        // Add booking_id if this is a booking sale
        if (bookingId) {
          saleItem.booking_id = bookingId;
        }

        // Store original USD price for reference if available
        if (item.price_usd !== undefined) {
          saleItem.price_usd = item.price_usd;
        }

        // Attach printable metadata
        saleItem.name = item.name;
        const prodMeta = products.find(p => p.id === item.id || p.productid === item.id);
        saleItem.unit = (prodMeta && (prodMeta.birlik_name || prodMeta.birlik)) ? (prodMeta.birlik_name || prodMeta.birlik) : (item.birlik || item.birlik_name || '-');

        return saleItem;
      });

      // Determine payments used for printing and payload
      const totalsForPrint = { totalSum, overall: overal };
      let paymentsForPrint = [];
      if (!isCustomer2 && !isCustomer3) {
        const paymentsToUse = (payments && Array.isArray(payments) && payments.length > 0) ? payments : (current.paymentType === 'hybrid' ? hybridPayments : []);
        if (Array.isArray(paymentsToUse) && paymentsToUse.length > 0) {
          paymentsForPrint = paymentsToUse;
        } else if (current.paymentType !== 'hybrid') {
          paymentsForPrint = [
            { method: current.paymentType, amount: overal, currency: 'UZS' }
          ];
        }
      }

      let payload = {
        customer: current.name,
        paymentType: current.paymentType,
        delivery: current.delivery,
        items,
        delivery_price: Number(deliveryPrice) || 0,
      };

      // Include payments only for customer1/guest (not for customer2 or customer3)
      if (!isCustomer2 && !isCustomer3 && paymentsForPrint.length > 0) {
        payload.payments = paymentsForPrint;
      }

      if (selectedCustomer3) {
        payload.customer_type = 'customer3';
        payload.customer_id = selectedCustomer3.id;
      } else if (selectedCustomer2) {
        payload.customer_type = 'customer2';
        payload.customer_id = selectedCustomer2.id;
      } else if (selectedCustomer) {
        payload.customer_type = 'customer1';
        payload.customer_id = selectedCustomer.id;
      } else {
        payload.customer_type = 'customer1';
        payload.customer_id = null;
      }

      const res = await fetch('/api/sales', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'x-owner-id': (user && (user.ownerId || user.id)) ? String(user.ownerId || user.id) : '',
          'x-staff-id': user && user.staffId ? String(user.staffId) : ''
        },
        body: JSON.stringify(payload),
        signal: abortController.signal
      });

      const result = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(result.error || `HTTP error! status: ${res.status}`);
      }

      // Update booking status if this was a booking sale
      if (bookingId && result.sellBatchID) {
        try {
          const bookingUpdateRes = await fetch(`/api/bookings/${bookingId}/status`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              status: 1, // confirmed
              salebatchid: result.sellBatchID
            })
          });
          if (!bookingUpdateRes.ok) {
            console.error('Failed to update booking status');
          }
        } catch (error) {
          console.error('Error updating booking status:', error);
        }
      }

      // Record payment transactions for customer1/guest sales
      if (!isCustomer2 && !isCustomer3 && paymentsForPrint.length > 0) {
        // Map payment method names to numeric types: cash=0, terminal=1, card=2, dollars=3
        const paymentMethodMap = {
          'cash': 0,
          'terminal': 1,
          'card': 2,
          'dollars': 3
        };

        // Determine customer type: 1 for customer1, 3 for guest (we'll use 1 for both)
        const customerType = selectedCustomer ? 1 : 1;

        // Record each payment as a transaction
        for (const payment of paymentsForPrint) {
          const paymentType = paymentMethodMap[payment.method] || 0;
          const amount = Number(payment.amount) || 0;

          if (amount > 0) {
            try {
              await fetch('/api/payment-transactions', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`,
                  'x-owner-id': (user && (user.ownerId || user.id)) ? String(user.ownerId || user.id) : '',
                  'x-staff-id': user && user.staffId ? String(user.staffId) : ''
                },
                body: JSON.stringify({
                  customer_type: customerType,
                  action: true, // payment
                  type: paymentType,
                  amount: amount
                })
              });
            } catch (error) {
              console.error('Error recording payment transaction:', error);
              // Don't fail the entire sale if payment transaction recording fails
            }
          }
        }
      }

      if (isMounted.current && !abortController.signal.aborted) {
        // Snapshot cart for printing, then clear UI immediately
        const cartSnapshot = [...cart];

        // UI feedback first (non-blocking)
        try { toast.success('Sotuv muvaffaqiyatli amalga oshirildi!'); } catch (_) { }

        // Clear cart and reset selections; set payment type back to empty
        updateCustomer(current.id, { cart: [], paymentType: '', delivery: false });
        setDeliveryPrice('');
        setSelectedCustomer(null);
        setSelectedCustomer2(null);
        setSelectedCustomer3(null);
        setShowSaleConfirmModal(false);
        setShowMultiplePaymentModal(false);
        setHybridPayments([]);
        // Clear booking state
        setBookingId(null);
        setIsBookingSale(false);

        // Print receipt if requested
        if (shouldPrint) {
          try {
            // Prefer selected store metadata for header
            const selectedStore = stores.find(s => (s.id || s.ID) === selectedStoreId) || null;
            const business = {
              name: (selectedStore && (selectedStore.name || selectedStore.store_name)) || 'POS',
              address: (selectedStore && (selectedStore.address || selectedStore.location)) || '',
              phone: (selectedStore && (selectedStore.phone || selectedStore.tel)) || ''
            };
            await printing.printSaleReceipt({
              business,
              sale: result,
              cart: cartSnapshot,
              payments: paymentsForPrint,
              deliveryPrice: Number(deliveryPrice) || 0,
              totals: totalsForPrint,
              options: { width: 32, type: 'epson' }
            });
          } catch (e) {
            try { toast.error('Chop etishda xatolik: ' + (e?.message || e)); } catch (_) { }
          }
        }
      }
    } catch (err) {
      if (err.name !== 'AbortError' && isMounted.current) {
        setSaleStatus({ type: 'danger', message: err.message || 'Xatolik yuz berdi' });
      }
    } finally {
      setIsSubmitting(false);
      abortController.abort(); // Clean up
    }
  };


  // Helper to fetch and cache product quantity
  const fetchAndCacheProductQuantity = useCallback(async (product) => {
    const cacheKey = `${product.productid}_${selectedStoreId}`;
    if (!product || !product.productid || productQuantities[cacheKey] !== undefined || loadingQuantities[cacheKey]) return;

    setLoadingQuantities(prev => ({ ...prev, [cacheKey]: true }));

    const abortController = new AbortController();

    try {
      // IMPORTANT: fetch sellable stock (quantity_remaining minus ACTIVE bookings)
      const res = await fetch(
        `/api/products/${product.productid}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          signal: abortController.signal
        }
      );

      if (!res.ok) {
        throw new Error(`Failed to fetch batches: ${res.status} ${res.statusText}`);
      }

      const batches = await res.json();

      // Only continue if the request wasn't aborted
      if (abortController.signal.aborted) return;

      let quantity = 0;
      if (!product.barcode || product.costing_method === 'FIFO') {
        // FIFO: sum available_quantity (already subtracts bookings)
        quantity = batches
          .filter(b => Number(b.available_quantity) > 0)
          .reduce((sum, b) => sum + Number(b.available_quantity || 0), 0);
      } else {
        // Specific: endpoint already excludes booked barcodes, so available_quantity is sellable
        quantity = batches
          .filter(b => (b.status || '').toLowerCase() === 'available')
          .reduce((sum, b) => sum + Number(b.available_quantity || 0), 0);
      }

      setProductQuantities(prev => ({ ...prev, [cacheKey]: quantity }));
    } catch (e) {
      if (e.name !== 'AbortError') {
        console.error('Error fetching product quantity:', e);
        setProductQuantities(prev => ({ ...prev, [cacheKey]: 'Xatolik' }));
      }
    } finally {
      if (!abortController.signal.aborted) {
        setLoadingQuantities(prev => ({ ...prev, [cacheKey]: false }));
      }
    }
  }, [token, productQuantities, loadingQuantities, selectedStoreId, isBookingSale, bookingExcludeQuery]);







  // Global request management
  const isMounted = useRef(true);
  const requestControllers = useRef(new Map());

  // Setup and cleanup for request management
  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
      // Abort all active requests on unmount
      requestControllers.current.forEach((controller) => {
        controller.abort();
      });
      requestControllers.current.clear();
    };
  }, []);

  // Setup and cleanup for request management
  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
      // Abort all active requests on unmount
      requestControllers.current.forEach((controller) => {
        controller.abort();
      });
      requestControllers.current.clear();
    };
  }, []);

  // Helper function to create a cancellable fetch request
  const createCancellableFetch = (key) => {
    // Cancel previous request with same key if exists
    if (requestControllers.current.has(key)) {
      requestControllers.current.get(key).abort();
    }

    // Create new abort controller
    const controller = new AbortController();
    requestControllers.current.set(key, controller);

    return {
      controller,
      cancel: () => {
        controller.abort();
        requestControllers.current.delete(key);
      },
      cleanup: () => {
        requestControllers.current.delete(key);
      }
    };
  };

  const filteredCustomers = customerSearch
    ? allCustomers.filter(c =>
      c.name.toLowerCase().includes(customerSearch.toLowerCase()) ||
      (c.phone && c.phone.includes(customerSearch))
    )
    : [];

  const filteredCustomer2s = customer2Search
    ? allCustomer2s.filter(c =>
      c.name.toLowerCase().includes(customer2Search.toLowerCase()) ||
      (c.phone && c.phone.includes(customer2Search))
    )
    : [];

  // Removed customer3 search via input; selection handled through history modal only

  // Search customer2s
  useEffect(() => {
    if (!customer2Search) return;

    setLoadingCustomer2s(true);
    const abortController = new AbortController();

    fetch(`/api/customer2/search?q=${encodeURIComponent(customer2Search)}`, {
      signal: abortController.signal,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (isMounted.current) {
          setAllCustomer2s(Array.isArray(data) ? data : []);
          setLoadingCustomer2s(false);
        }
      })
      .catch(err => {
        if (err.name !== 'AbortError' && isMounted.current) {
          console.error('Error searching customer2s:', err);
          setLoadingCustomer2s(false);
        }
      });

    return () => {
      abortController.abort();
    };
  }, [customer2Search, token]);

  // Utility to always get the product name from backend field
  const getProductName = (prod) => prod.name;

  // Add state to cache earliest batch info for each product
  const [earliestBatchByProductId, setEarliestBatchByProductId] = useState({});
  // Cache all FIFO batches per product (by store) to support per-batch FIFO allocation
  const [allFifoBatchesByProductId, setAllFifoBatchesByProductId] = useState({});

  // Clear cache when store changes
  useEffect(() => {
    if (selectedStoreId !== null) {
      // Clear all cached data when store changes
      setProductQuantities({});
      setAllBarcodes([]);
      setBarcodesLoading(false);
      setEarliestBatchByProductId({});
      setAllFifoBatchesByProductId({});
    }
  }, [selectedStoreId]);

  // Pre-load all barcodes when products change or store changes
  useEffect(() => {
    if (!Array.isArray(products) || products.length === 0 || !token || !selectedStoreId) return;

    const loadAllBarcodes = async () => {
      setBarcodesLoading(true);
      const allBarcodesList = [];

      try {
        // Process all products
        for (const prod of products) {
          if (!prod.productid) continue;

          if (prod.costing_method === 'FIFO' || prod.costing_method !== 'Specific') {
            // For FIFO products, use the barcode from the product itself
            if (prod.barcode) {
              allBarcodesList.push({
                barcode: prod.barcode,
                product: prod,
                type: 'FIFO',
                batch: null
              });
            }
          } else if (prod.costing_method === 'Specific') {
            // For Specific products, fetch batches and their barcodes
            try {
              // IMPORTANT: use available-batches so booked barcodes are not included
              const url = `/api/products/${prod.productid}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId))}${isBookingSale ? bookingExcludeQuery : ''}`;
              const res = await fetch(url, {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              });

              if (!res.ok) {
                console.error(`Failed to fetch batches for product ${prod.productid}:`, res.status, res.statusText);
                continue;
              }

              const batches = await res.json();
              console.log(`Fetched ${batches.length} batches for product ${prod.name}:`, batches);

              // Add each batch's barcode to the list
              batches.forEach(batch => {
                if (batch.barcode && Number(batch.available_quantity || 0) > 0) {
                  allBarcodesList.push({
                    barcode: batch.barcode,
                    product: prod,
                    type: 'Specific',
                    batch: batch
                  });
                  console.log(`Added barcode ${batch.barcode} for product ${prod.name}, batch ${batch.id}`);
                }
              });
            } catch (err) {
              console.error(`Error fetching batches for product ${prod.name}:`, err);
            }
          }
        }

        console.log(`Total barcodes loaded: ${allBarcodesList.length}`, allBarcodesList);
        setAllBarcodes(allBarcodesList);
      } catch (err) {
        console.error('Error loading barcodes:', err);
      } finally {
        setBarcodesLoading(false);
      }
    };

    loadAllBarcodes();
  }, [products, token, selectedStoreId, isBookingSale, bookingExcludeQuery]);

  // Fetch earliest batch for each product when products change
  useEffect(() => {
    if (!Array.isArray(products) || products.length === 0 || !token || !selectedStoreId) return;

    // Track active requests to cancel them on cleanup
    const activeControllers = new Map();

    products.forEach(async prod => {
      const cacheKey = `${prod.productid}_${selectedStoreId}`;
      if (!prod.productid || earliestBatchByProductId[cacheKey]) return;

      // Create abort controller for this product
      const controller = new AbortController();
      activeControllers.set(cacheKey, controller);

      try {
        // IMPORTANT: use available-batches so price batch list excludes fully booked FIFO batches
        const res = await fetch(`/api/products/${prod.productid}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId))}${isBookingSale ? bookingExcludeQuery : ''}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          signal: controller.signal
        });

        if (!res.ok) {
          console.error(`Failed to fetch batches for product ${prod.productid}:`, res.status, res.statusText);
          return;
        }

        const batches = await res.json();

        // Only continue if the request wasn't aborted
        if (controller.signal.aborted) return;

        if (Array.isArray(batches) && batches.length > 0) {
          // Sort by created_at ASC to get the earliest batch for price display
          const earliest = batches.slice().sort((a, b) => {
            if (a.created_at && b.created_at) return new Date(a.created_at) - new Date(b.created_at);
            return (a.id || 0) - (b.id || 0);
          })[0];

          if (!controller.signal.aborted) {
            setEarliestBatchByProductId(prev => ({ ...prev, [cacheKey]: earliest }));
            const sortedFifo = batches
              .filter(b => Number(b.available_quantity || 0) > 0)
              .slice()
              .sort((a, b) => {
                if (a.created_at && b.created_at) return new Date(a.created_at) - new Date(b.created_at);
                return (a.id || 0) - (b.id || 0);
              });
            setAllFifoBatchesByProductId(prev => ({ ...prev, [cacheKey]: sortedFifo }));
          }
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error(`Error fetching batches for product ${prod.name}:`, err);
        }
      } finally {
        // Clean up controller reference
        activeControllers.delete(cacheKey);
      }
    });

    // Cleanup function to cancel all requests when component unmounts or dependencies change
    return () => {
      activeControllers.forEach(controller => {
        controller.abort();
      });
    };
  }, [products, token, selectedStoreId, isBookingSale, bookingExcludeQuery]); // Added selectedStoreId to trigger refetch when store changes

  // Helper: used quantity per batch for a given product from current cart
  const getUsedQtyByBatchForProduct = useCallback((productId) => {
    const usedMap = new Map();
    cart.forEach(item => {
      if (item.id === productId && item.batch_id) {
        usedMap.set(item.batch_id, (usedMap.get(item.batch_id) || 0) + item.qty);
      }
    });
    return usedMap;
  }, [cart]);

  // Helper: ensure FIFO batches are cached for a product; returns sorted available batches
  const ensureFifoBatchesCached = useCallback(async (product) => {
    const cacheKey = `${product.productid}_${selectedStoreId}`;
    let batches = allFifoBatchesByProductId[cacheKey];
    if (!Array.isArray(batches)) {
      try {
        // IMPORTANT: use available-batches so FIFO allocation never uses booked quantity
        const res = await fetch(
          `/api/products/${product.productid}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        if (!res.ok) return [];
        const data = await res.json();
        batches = (Array.isArray(data) ? data : [])
          .filter(b => Number(b.available_quantity || 0) > 0)
          .sort((a, b) => {
            if (a.created_at && b.created_at) return new Date(a.created_at) - new Date(b.created_at);
            return (a.id || 0) - (b.id || 0);
          });
        setAllFifoBatchesByProductId(prev => ({ ...prev, [cacheKey]: batches }));
      } catch (_) {
        return [];
      }
    }
    return batches || [];
  }, [allFifoBatchesByProductId, selectedStoreId, token, isBookingSale, bookingExcludeQuery]);

  // Helper: allocate N units across FIFO batches considering cart usage
  const allocateUnitsAcrossBatches = (batches, usedMap, units) => {
    const allocations = [];
    let remaining = units;
    for (const batch of batches) {
      if (remaining <= 0) break;
      const used = usedMap.get(batch.id) || 0;
      // available_quantity already excludes active bookings (except excludeBookingId in booking-sale)
      const available = Math.max(0, Number(batch.available_quantity || 0) - used);
      if (available <= 0) continue;
      const take = Math.min(available, remaining);
      allocations.push({ batch, qty: take });
      remaining -= take;
    }
    return allocations;
  };

  // Helper: compute price in UZS and USD (if applicable) for a batch
  const computeBatchPrices = (batch, product) => {
    let basePrice = (batch.sellingprice !== undefined && batch.sellingprice !== null)
      ? Number(batch.sellingprice)
      : (product.price || 0);
    if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && isFirstPrice && batch.first_price !== undefined) {
      basePrice = Number(batch.first_price);
    }
    let priceUZS = basePrice;
    let priceUSD = null;
    if (batch.currency === 'USD') {
      priceUSD = basePrice;
      if (!exchangeRate || isNaN(exchangeRate) || exchangeRate <= 0) {
        console.error('Invalid exchange rate for FIFO add:', exchangeRate);
      } else {
        priceUZS = Math.round(basePrice * exchangeRate);
      }
    }
    return { priceUZS, priceUSD };
  };

  // Format numbers with up to 3 decimals, trimming trailing zeros
  const formatAmount = (value) => {
    const num = Number(value);
    if (!isFinite(num)) return '0';
    return num.toLocaleString('uz-UZ', { maximumFractionDigits: 3 }).replace(/,/g, ' ');
  };

  // Sanitize decimal input: accept both ',' and '.', clamp to maxDecimals, strip invalid chars
  const sanitizeDecimalInput = (rawValue, maxDecimals = 3) => {
    let v = String(rawValue ?? '').replace(',', '.');
    // Keep digits and dots only
    v = v.replace(/[^0-9.]/g, '');
    if (!v) return '';
    // Ensure single dot
    const parts = v.split('.');
    if (parts.length > 2) {
      v = parts[0] + '.' + parts.slice(1).join('');
    }
    const dotIndex = v.indexOf('.');
    if (dotIndex !== -1) {
      const intPart = v.slice(0, dotIndex);
      const decPart = v.slice(dotIndex + 1, dotIndex + 1 + maxDecimals);
      v = `${intPart}.${decPart}`;
    }
    return v;
  };

  // Main: add FIFO product units into cart by per-batch rows
  const addFifoProductUnits = useCallback(async (product, units = 1) => {
    if (!product || !product.productid || units <= 0) return;
    const productId = product.productid;
    const batches = await ensureFifoBatchesCached(product);
    if (!batches || batches.length === 0) return;
    const usedMap = getUsedQtyByBatchForProduct(productId);
    const allocations = allocateUnitsAcrossBatches(batches, usedMap, units);
    if (!allocations.length) return;

    const newCart = [...cart];
    allocations.forEach(({ batch, qty }) => {
      const { priceUZS, priceUSD } = computeBatchPrices(batch, product);
      // Merge with existing same-batch row if present
      const existingIndex = newCart.findIndex(ci => ci.id === productId && ci.batch_id === batch.id);
      if (existingIndex !== -1) {
        const existing = newCart[existingIndex];
        const updated = { ...existing, qty: existing.qty + qty };
        // Preserve USD price fields if applicable
        if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
          updated.price_usd = priceUSD;
          updated.currency_source = 'USD';
          updated.price = priceUZS; // keep UZS for display
        } else {
          updated.price = priceUZS;
        }
        newCart[existingIndex] = updated;
      } else {
        const cartItem = {
          ...product,
          id: productId,
          name: getProductName(product),
          batch_id: batch.id,
          qty,
          price: priceUZS
        };
        if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
          cartItem.price_usd = priceUSD;
          cartItem.currency_source = 'USD';
        }
        newCart.push(cartItem);
      }
    });

    updateCustomer(current.id, { cart: newCart });
  }, [cart, current?.id, ensureFifoBatchesCached, getUsedQtyByBatchForProduct, selectedCustomer3, isFirstPrice, exchangeRate, selectedStoreId, updateCustomer]);

  useEffect(() => {
    if (!selectedCustomer3) {
      // Revert prices to SellingPrice/price if customer3 is deselected
      const updatedCart = cart.map(item => {
        if (!item.batch_id) return item;
        // fallback to earliest batch for product
        const cacheKey = `${item.id || item.productid}_${selectedStoreId}`;
        const batch = earliestBatchByProductId[cacheKey];
        return {
          ...item,
          price: (batch && (batch.sellingprice)) || item.price
        };
      });

      // Only update if cart actually changed
      const hasChanges = updatedCart.some((item, index) => {
        const originalItem = cart[index];
        return originalItem && item.price !== originalItem.price;
      });

      if (hasChanges && isMounted.current) {
        updateCustomer(current.id, { cart: updatedCart });
      }
      return;
    }

    // Only run this effect if we have cart items with batch_id that need price updates
    const itemsNeedingUpdate = cart.filter(item =>
      item.batch_id && !item._userEditedPrice
    );

    if (itemsNeedingUpdate.length === 0) return;

    // Track active requests to cancel them on cleanup
    const activeControllers = new Map();

    // For each cart item with batch_id, fetch the correct batch and set price to first_price (unless user has edited)
    const fetchPromises = itemsNeedingUpdate.map(async (item, index) => {
      const productId = item.productid || item.id;
      if (!productId) return item;

      // Create abort controller for this item
      const controller = new AbortController();
      activeControllers.set(`item_${index}`, controller);

      try {
        const res = await fetch(`/api/products/${productId}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          signal: controller.signal
        });

        if (!res.ok) {
          console.error(`Failed to fetch batches for product ${productId}:`, res.status, res.statusText);
          return item;
        }

        const batches = await res.json();

        // Only continue if the request wasn't aborted
        if (controller.signal.aborted) return item;

        const batch = batches.find(b => b.id === item.batch_id);
        if (batch && batch.first_price) {
          let price;
          let priceUSD = null;
          if (batch.currency === 'USD') {
            priceUSD = batch.first_price;
            price = Math.round(batch.first_price * exchangeRate);
          } else {
            price = batch.first_price;
          }
          let updatedItem = { ...item, price };
          // For Customer3 USD, store USD price
          if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
            updatedItem.price_usd = priceUSD;
            updatedItem.currency_source = 'USD';
          }
          return updatedItem;
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Error fetching batch for item', item, err);
        }
      } finally {
        // Clean up controller reference
        activeControllers.delete(`item_${index}`);
      }

      return item;
    });

    Promise.all(fetchPromises)
      .then(updatedItems => {
        if (isMounted.current) {
          // Create a map of updated items for easy lookup
          const updatedItemsMap = new Map();
          updatedItems.forEach((updatedItem, index) => {
            updatedItemsMap.set(itemsNeedingUpdate[index].batch_id, updatedItem);
          });

          // Update only the items that actually changed
          const newCart = cart.map(item => {
            if (item.batch_id && updatedItemsMap.has(item.batch_id)) {
              const updatedItem = updatedItemsMap.get(item.batch_id);
              if (updatedItem.price !== item.price) {
                return updatedItem;
              }
            }
            return item;
          });

          // Only update if there are actual changes
          const hasChanges = newCart.some((item, index) => {
            const originalItem = cart[index];
            return originalItem && item.price !== originalItem.price;
          });

          if (hasChanges) {
            updateCustomer(current.id, { cart: newCart });
          }
        }
      })
      .catch(err => {
        console.error('Error updating cart prices:', err);
      });

    // Cleanup function to cancel all requests when component unmounts or dependencies change
    return () => {
      activeControllers.forEach(controller => {
        controller.abort();
      });
    };
  }, [selectedCustomer3, token, selectedStoreId]); // Added selectedStoreId to trigger refetch when store changes

  const handleToggleFirstPrice = async () => {
    console.log('TOGGLE handleToggleFirstPrice', { cart, isFirstPrice });
    const newIsFirstPrice = !isFirstPrice;
    setIsFirstPrice(newIsFirstPrice);

    // Track active requests to cancel them on cleanup
    const activeControllers = new Map();

    try {
      if (newIsFirstPrice) {
        // Set all cart items to first_price (converted to UZS if needed, if batch found)
        const fetchPromises = cart.map(async (item, index) => {
          const productId = item.productid || item.id;
          if (!productId) return item;

          // Create abort controller for this item
          const controller = new AbortController();
          activeControllers.set(`item_${index}`, controller);

          try {
            const res = await fetch(`/api/products/${productId}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              },
              signal: controller.signal
            });

            if (!res.ok) {
              console.error(`Failed to fetch batches for product ${productId}:`, res.status, res.statusText);
              return item;
            }

            const batches = await res.json();

            // Only continue if the request wasn't aborted
            if (controller.signal.aborted) return item;

            let batch = null;
            if (item.batch_id) {
              batch = batches.find(b => b.id === item.batch_id);
            }
            if (!batch && Array.isArray(batches) && batches.length > 0) {
              batch = batches[0]; // fallback to first batch
            }
            if (batch && batch.first_price) {
              let price;
              let priceUSD = null;
              if (batch.currency === 'USD') {
                priceUSD = batch.first_price;
                price = Math.round(batch.first_price * exchangeRate);
              } else {
                price = batch.first_price;
              }
              let updatedItem = { ...item, price };
              // For Customer3 USD, store USD price
              if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
                updatedItem.price_usd = priceUSD;
                updatedItem.currency_source = 'USD';
              }
              return updatedItem;
            }
          } catch (err) {
            if (err.name !== 'AbortError') {
              console.error('Error fetching batch for item', item, err);
            }
          } finally {
            // Clean up controller reference
            activeControllers.delete(`item_${index}`);
          }

          return item;
        });

        const newCart = await Promise.all(fetchPromises);
        if (isMounted.current) {
          updateCustomer(current.id, { cart: newCart });
        }
      } else {
        // Revert to SellingPrice/price (converted to UZS if needed, if batch found)
        const fetchPromises = cart.map(async (item, index) => {
          const productId = item.productid || item.id;
          if (!productId) return item;

          // Create abort controller for this item
          const controller = new AbortController();
          activeControllers.set(`item_${index}`, controller);

          try {
            const res = await fetch(`/api/products/${productId}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              },
              signal: controller.signal
            });

            if (!res.ok) {
              console.error(`Failed to fetch batches for product ${productId}:`, res.status, res.statusText);
              return item;
            }

            const batches = await res.json();

            // Only continue if the request wasn't aborted
            if (controller.signal.aborted) return item;

            let batch = null;
            if (item.batch_id) {
              batch = batches.find(b => b.id === item.batch_id);
            }
            if (!batch && Array.isArray(batches) && batches.length > 0) {
              batch = batches[0]; // fallback to first batch
            }
            if (batch && (batch.sellingprice !== undefined)) {
              const selling = batch.sellingprice;
              let price;
              let priceUSD = null;
              if (batch.currency === 'USD') {
                priceUSD = selling;
                price = Math.round(selling * exchangeRate);
              } else {
                price = selling;
              }
              let updatedItem = { ...item, price };
              // For Customer3 USD, store USD price
              if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
                updatedItem.price_usd = priceUSD;
                updatedItem.currency_source = 'USD';
              }
              return updatedItem;
            }
          } catch (err) {
            if (err.name !== 'AbortError') {
              console.error('Error fetching batch for item', item, err);
            }
          } finally {
            // Clean up controller reference
            activeControllers.delete(`item_${index}`);
          }

          return item;
        });

        const newCart = await Promise.all(fetchPromises);
        if (isMounted.current) {
          updateCustomer(current.id, { cart: newCart });
        }
      }
    } catch (error) {
      console.error('Error toggling first price:', error);
    } finally {
      // Cancel any remaining requests
      activeControllers.forEach(controller => {
        controller.abort();
      });
    }
  };

  const [showCartSection, setShowCartSection] = useState(false);

  return (
    <div className="container-fluid p-3">
      {/* Customer Tabs */}
      <div className="d-flex align-items-center mb-3">
        <div className='d-none d-md-block w-50'>
          {customers.map((c, idx) => (
            <div
              key={c.id}
              className={`btn me-2 ${activeCustomer === c.id ? 'btn-dark' : 'btn-outline-dark'}`}
              onClick={() => setActiveCustomer(c.id)}
              style={{ position: 'relative' }}
            >
              Mijoz {c.id}
              <span
                className="ms-2 text-danger"
                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                onClick={e => { e.stopPropagation(); removeCustomer(c.id); }}
              >
                ×
              </span>
            </div>
          ))}
          <button className="btn btn-primary ms-2" onClick={addCustomer}>
            ➕ Mijoz qo'shish
          </button>
        </div>
        <div className='w-100 w-md-50 d-flex justify-content-end'>
          <div style={{ minWidth: 220 }}>
            <StoreSelect
              value={selectedStoreId}
              onChange={id => setSelectedStoreId(id)}
              className="mb-2"
            />
          </div>
          {/* New button for switching two main section */}
        </div>
      </div>
      <div className='d-block d-md-none my-2 d-flex justify-content-center'>
        <button className='btn btn-outline-success' style={{ fontSize: 22 }} onClick={() => setShowCartSection(prev => !prev)}>
          {showCartSection ? <FaBox /> : <FaShoppingCart />}
          <span className='ms-2' style={{ fontSize: 15 }}>{showCartSection ? 'Mahsulotlar' : 'Savat'}</span>
        </button>
      </div>
      <AddCustomer1Modal open={showCustomerModal} onClose={() => { setShowCustomerModal(false); }} onSelected={c => { setSelectedCustomer(c); }} />
      <AddCustomer2Modal open={showCustomer2Modal} onClose={() => setShowCustomer2Modal(false)} />
      <AddCustomer3Modal open={showCustomer3Modal} onClose={() => setShowCustomer3Modal(false)} onCreated={c => {
        setAllCustomer3s(prev => [c, ...prev]);
        setSelectedCustomer3(c);
      }} />
      <div className="row" style={{ minHeight: '70vh' }}>
        {/* Left: Categories/Products */}
        <div className={`col-md-6 border-end${showCartSection ? ' d-none d-md-block' : ''}`}>
          {/* Barcode input */}
          <div className='d-flex mb-3'>
            <input
              type="text"
              className="form-control "
              placeholder="Qidiruv"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <input
              type="text"
              className="form-control "
              placeholder="Shtrix-kod skanerlash yoki kiriting"
              value={barcodeInput}
              onChange={e => setBarcodeInput(e.target.value)}

            />
          </div>
          <div className="mb-3">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${categoryTab === 'Kategoriyalar' ? 'active' : ''}`}
                  onClick={() => setCategoryTab('Kategoriyalar')}
                >
                  Kategoriyalar
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${categoryTab === 'Mahsulotlar' ? 'active' : ''}`}
                  onClick={() => setCategoryTab('Mahsulotlar')}
                >
                  Mahsulotlar
                </button>
              </li>
              <li className="nav-item ms-auto">
                <button
                  className={`nav-link border-0 bg-transparent py-2 px-3 d-flex align-items-center ${!showImages ? 'text-primary' : 'text-muted'}`}
                  onClick={() => setShowImages(!showImages)}
                  title={showImages ? "Rasmlarni yashirish" : "Rasmlarni ko'rsatish"}
                  style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                >
                  {showImages ? <FaImage size={18} /> : <FaRegImage size={18} />}
                  <span className="ms-2 d-none d-sm-inline" style={{ fontSize: '13px', fontWeight: '500' }}>
                    {showImages ? "Rasmli" : "Rasmsiz"}
                  </span>
                </button>
              </li>
            </ul>
          </div>

          {categoryTab === 'Kategoriyalar' && (
            <div className="overflow-auto" style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
              <div className="row g-3">
                {categories
                  .filter(cat => !search || cat.name.toLowerCase().includes(search.toLowerCase()))
                  .map(cat => (
                    <div key={cat.id} className="col-6 col-sm-4 col-md-2">
                      <div
                        className="card h-100 shadow-sm bg-light border-0"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setSelectedCategoryId(cat.id);
                          setCategoryTab('Mahsulotlar');
                        }}
                      >
                        {showImages && (
                          <div className="p-2">
                            <div className="ratio ratio-1x1">
                              <img
                                src={cat.image ? `${cat.image.startsWith('/') ? '' : '/'}${cat.image}` : 'https://via.placeholder.com/300'}
                                alt={cat.name}
                                className="w-100 h-100"
                                style={{ objectFit: 'cover', borderRadius: 8 }}
                              />
                            </div>
                          </div>
                        )}
                        <div className="card-body py-2">
                          <div className="fw-bold text-center" style={{ fontSize: 14 }}>{cat.name}</div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          {categoryTab === 'Mahsulotlar' && (
            <div className="row g-3" style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', padding: '0 12px' }}>
              {products
                .filter(prod => selectedCategoryId == null || prod.category_id === selectedCategoryId || prod.CategoryID === selectedCategoryId)
                .filter(prod => {
                  if (categoryTab === 'Mahsulotlar' && search && !prod.name.toLowerCase().includes(search.toLowerCase())) return false;
                  if (!barcodeSearch) return true;
                  // Check if any barcode for this product matches the search
                  const productBarcodes = allBarcodes.filter(item => item.product.productid === prod.productid);
                  return productBarcodes.some(item =>
                    item.barcode && item.barcode.toLowerCase().includes(barcodeSearch.toLowerCase())
                  );
                })
                // Store filtering: only show products from selected store, or all if not selected

                .map(prod => {
                  // For Specific products, we need to check if they have any available batches
                  const isSpecificProduct = prod.costing_method === 'Specific';
                  const cacheKey = `${prod.productid}_${selectedStoreId}`;

                  // Check if this specific product has available batches
                  const productBarcodes = allBarcodes.filter(item => item.product.productid === prod.productid);
                  const hasAvailableBatches = isSpecificProduct ? productBarcodes.length > 0 : true;

                  // Check if barcodes are still loading
                  const isBarcodesLoading = barcodesLoading;

                  const cartItem = cart.find(item => item.id === prod.productid && (!item.batch_id || item.batch_id === prod.batch_id));
                  // Fix: Only fetch product quantity if not already fetched or loading
                  if (productQuantities[cacheKey] === undefined && !loadingQuantities[cacheKey]) {
                    fetchAndCacheProductQuantity(prod);
                  }
                  const earliestBatch = earliestBatchByProductId[cacheKey];

                  // --- NEW: Calculate available quantity (Total Stock - In Cart) ---
                  const totalStock = productQuantities[cacheKey] || 0;
                  const inCartQty = cart
                    .filter(ci => ci.id === prod.productid)
                    .reduce((sum, ci) => sum + ci.qty, 0);
                  const availableQty = (typeof totalStock === 'number') ? totalStock - inCartQty : totalStock;
                  const isOutOfStock = (typeof availableQty === 'number') && availableQty <= 0;
                  // --- END NEW ---

                  const productStoreId = earliestBatch ? (earliestBatch.store_id || earliestBatch.storeid) : null;
                  // If a store is selected, disable products not in that store
                  const isStoreMismatch = selectedStoreId && productStoreId && Number(productStoreId) !== Number(selectedStoreId);
                  // Fix: Correct the disabling logic - don't disable if barcodes are still loading
                  const isDisabled = (selectedStoreId && productStoreId && Number(productStoreId) !== Number(selectedStoreId)) ||
                    (isSpecificProduct && !hasAvailableBatches && !isBarcodesLoading) || (isOutOfStock && typeof availableQty === 'number');
                  return (
                    <div key={prod.productid} className="col-6 col-md-3 d-flex">
                      <div
                        className="card flex-fill mb-2 d-flex flex-column justify-content-between rounded-4"
                        style={{
                          cursor: isDisabled || isOutOfStock ? 'not-allowed' : 'pointer',
                          minHeight: showImages ? 155 : 80,
                          opacity: isDisabled || isOutOfStock ? 0.5 : 1,
                          border: isStoreMismatch ? '1px solid #9e1c02' : '1px solid #969b97',
                          boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                        }}
                        onClick={async () => {
                          if (isDisabled || isOutOfStock) return;
                          // For Specific products, ensure batches are loaded before opening modal
                          if (isSpecificProduct && !hasAvailableBatches && !isBarcodesLoading) {
                            // Try to load batches first
                            try {
                              const res = await fetch(`/api/products/${prod.productid}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`, {
                                headers: {
                                  'Authorization': `Bearer ${token}`,
                                  'Content-Type': 'application/json'
                                }
                              });

                              if (!res.ok) {
                                console.error(`Failed to fetch batches for product ${prod.productid}:`, res.status, res.statusText);
                                return;
                              }

                              const batches = await res.json();
                              if (batches.length === 0) {
                                console.log(`No batches found for product ${prod.productid}`);
                                return;
                              }
                            } catch (err) {
                              console.error(`Error fetching batches for product ${prod.productid}:`, err);
                              return;
                            }
                          }
                          await openBatchModal(prod);
                        }}
                      >
                        {/* Image at the top */}
                        {showImages && (
                          <div className="d-flex justify-content-center align-items-center pt-2">
                            <div
                              className="rounded-3"
                              style={{
                                width: 80,
                                height: 80,
                                border: '1px solid #dee2e6',
                                background: '#fff',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <img
                                src={prod.photo ? `${prod.photo.startsWith('/') ? '' : '/'}${prod.photo}` : 'https://via.placeholder.com/180'}
                                alt={prod.name}
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            </div>
                          </div>
                        )}

                        <div className="card-body d-flex flex-column align-items-center justify-content-end pb-2 pt-1 px-2">
                          <div
                            className="fw-semibold text-center px-2 py-1 rounded-pill bg-light w-100"
                            style={{ fontSize: 13.5, lineHeight: 1.2 }}
                          >
                            {prod.name}
                          </div>
                          <div className="text-muted text-center mt-1 w-100" style={{ fontSize: 12.5 }}>
                            {(() => {
                              // Get the earliest batch for this product to display selling price
                              console.log('Product:', prod.name, 'Earliest batch:', earliestBatch);
                              console.log('Exchange rate:', exchangeRate);

                              let sellingPrice = 0;
                              let currency = 'UZS';

                              if (earliestBatch) {
                                // Try different possible field names for selling price
                                sellingPrice = Number(
                                  earliestBatch.sellingprice ??
                                  earliestBatch.SellingPrice ??
                                  earliestBatch.price ??
                                  earliestBatch.costperunit ??
                                  earliestBatch.cost_per_unit ??
                                  0
                                );
                                currency = earliestBatch.currency || 'UZS';
                                console.log('Calculated selling price:', sellingPrice, 'currency:', currency);
                              } else {
                                // Fallback to product price if no batch info available
                                sellingPrice = Number(prod.price || 0);
                                console.log('Using fallback product price:', sellingPrice);
                              }

                              if (sellingPrice > 0) {
                                console.log('Displaying price:', sellingPrice, 'in', currency);

                                if (currency === 'USD') {
                                  // Check if exchangeRate is valid
                                  if (!exchangeRate || isNaN(exchangeRate) || exchangeRate <= 0) {
                                    console.error('Invalid exchange rate:', exchangeRate);
                                    return <>Narx: {sellingPrice.toFixed(2)}$ (Exchange rate error)</>;
                                  }
                                  const convertedPrice = sellingPrice * exchangeRate;
                                  console.log('Converting USD to UZS:', sellingPrice, '*', exchangeRate, '=', convertedPrice);

                                  return (<>{sellingPrice.toFixed(2)}$ ≈ {convertedPrice.toLocaleString('uz-UZ', { maximumFractionDigits: 2 })}</>);
                                } else {
                                  return <>{formatAmount(sellingPrice)}</>;
                                }
                              } else {
                                console.log('No valid price found, using fallback price:', prod.price);
                                return <>{formatAmount(prod.price || 0)}</>;
                              }
                            })()}
                          </div>

                          <div className="d-flex align-items-end justify-content-between mt-2 w-100" style={{ gap: '0.4rem' }}>
                            {/* Minus button on the left (only for FIFO products) */}
                            {prod.costing_method !== 'Specific' && (
                              <button
                                className="btn btn-outline-dark btn-sm"
                                style={{ width: 'clamp(30px, 4vw, 36px)', height: 'clamp(30px, 4vw, 36px)', padding: 0 }}
                                onClick={e => {
                                  e.stopPropagation();
                                  const productId = prod.productid;
                                  // Find last FIFO cart line for this product; if none, do nothing
                                  let index = -1;
                                  for (let i = cart.length - 1; i >= 0; i--) {
                                    if (cart[i].id === productId && cart[i].batch_id) {
                                      index = i;
                                      break;
                                    }
                                  }
                                  if (index !== -1) {
                                    const target = cart[index];
                                    let newCart;
                                    if (target.qty > 1) {
                                      newCart = cart.map((ci, i) => i === index ? { ...ci, qty: ci.qty - 1 } : ci);
                                    } else {
                                      newCart = cart.filter((_, i) => i !== index);
                                    }
                                    updateCustomer(current.id, { cart: newCart });
                                  }
                                }}
                                disabled={!cart.find(item => item.id === prod.productid && item.batch_id) || isDisabled}
                              >
                                -
                              </button>
                            )}

                            {/* Quantity display in the center */}
                            <div className='flex-grow-1 d-flex flex-column justify-content-center align-items-center' style={{ minWidth: '72px' }}>
                              <div className="text-success text-center" style={{ fontSize: 13, color: isOutOfStock ? 'red' : undefined }}>
                                {loadingQuantities[cacheKey]
                                  ? '...'
                                  : productQuantities[cacheKey] !== undefined
                                    ? (typeof availableQty === 'number'
                                      ? formatAmount(availableQty)
                                      : availableQty)
                                    : ''}
                              </div>
                            </div>

                            {/* Plus button on the right (only for FIFO products) */}
                            {prod.costing_method !== 'Specific' && (
                              <button
                                className="btn btn-outline-dark btn-sm"
                                style={{ width: 'clamp(30px, 4vw, 36px)', height: 'clamp(30px, 4vw, 36px)', padding: 0 }}
                                onClick={e => {
                                  e.stopPropagation();
                                  // NEW: allocate 1 unit using FIFO per-batch
                                  addFifoProductUnits(prod, 1);
                                }}
                                disabled={availableQty <= 0 || isDisabled}
                              >
                                +
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
        {/* Right: Cart and Checkout */}
        <div className={`col-md-6${showCartSection ? '' : ' d-none d-md-block'}`}>
          {/* Booking sale banner */}
          {isBookingSale && (
            <Alert variant="info" className="d-flex justify-content-between align-items-center mb-2">
              <span>
                <strong>Bron sotuvi:</strong> Bu bron mahsulotlarini sotish jarayoni.
                {bookingId && <span className="ms-2">Bron ID: {bookingId}</span>}
              </span>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => {
                  setBookingId(null);
                  setIsBookingSale(false);
                  updateCustomer(current.id, { cart: [] });
                  setDeliveryPrice('');
                }}
              >
                Bekor qilish
              </Button>
            </Alert>
          )}
          {/* Sale status alert */}
          {saleStatus && (
            <Alert variant={saleStatus.type} onClose={() => setSaleStatus(null)} dismissible>
              {saleStatus.message}
            </Alert>
          )}
          <div
            className="mb-2 rounded-4 "
            style={{
              height: '300px',
              overflowY: 'auto',
              boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
              padding: '1rem'

            }}
          >
            <table className="table  align-middle">
              <thead className="table-light">
                <tr>
                  <th>{totalQty === 0 ? '№' : <span className="badge bg-secondary" title="Jami soni">{totalQty}</span>}</th>
                  <th>Nom</th>
                  <th>Narx</th>
                  <th>Miqdor</th>
                  <th>Birlik</th>
                  <th>Summa</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {cart.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center">Mahsulot tanlang</td>
                  </tr>
                ) : (
                  cart.map((item, idx) => {
                    const product = products.find(p => p.id === item.id || p.productid === item.id);
                    // Determine batch info for this cart item
                    let batch = null;
                    if (item.batch_id) {
                      // Try to find the batch in earliestBatchByProductId or fetch if not present
                      const cacheKey = `${item.id}_${selectedStoreId}`;
                      batch = earliestBatchByProductId[cacheKey];
                      // If not found, try to get from product's batches (could be improved by caching all batches)
                      if (!batch && product) {
                        // fallback: use earliest batch
                        const productCacheKey = `${product.productid}_${selectedStoreId}`;
                        batch = earliestBatchByProductId[productCacheKey];
                      }
                    } else if (product) {
                      const productCacheKey = `${product.productid}_${selectedStoreId}`;
                      batch = earliestBatchByProductId[productCacheKey];
                    }
                    // Determine if this item is USD
                    const isUSD = batch && batch.currency === 'USD';
                    // Always show price in UZS for input
                    const displayPrice = isUSD ? Math.round((Number(item.price) || 0) * exchangeRate) : Number(item.price) || 0;
                    return (
                      <tr
                        key={
                          (!item.batch_id && !item.batch_barcode)
                            ? `fifo-${item.id}`
                            : `spec-${item.id}-${item.batch_barcode || item.batch_id}`
                        }
                        style={{ cursor: 'pointer' }}
                        onClick={async () => {
                          if (product) await openBatchModal(product);
                        }}
                      >
                        <td>{idx + 1}</td>
                        <td>{item.name}{item.batch_barcode ? ` (${item.batch_barcode})` : ''}</td>
                        <td>
                          {/*
  Price input logic:
  - For Customer1/2: always show and store price in UZS.
  - For Customer3: show and store price in their currency (UZS or USD).
  - Editing price updates cart state in correct currency, no conversion in input handler.
*/}
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={(() => {
                              // For Customer3, show price in their currency
                              if (selectedCustomer3 && selectedCustomer3.currency) {
                                // If item currency differs from customer currency, convert for display
                                if (item.currency && item.currency !== selectedCustomer3.currency) {
                                  if (item.currency === 'USD' && selectedCustomer3.currency === 'UZS') {
                                    return Math.round(item.price * exchangeRate);
                                  } else if (item.currency === 'UZS' && selectedCustomer3.currency === 'USD') {
                                    return +(item.price / exchangeRate).toFixed(2);
                                  }
                                }
                                return item.price;
                              }
                              // For Customer1/2, always show UZS
                              return item.price;
                            })()}
                            min={0}
                            onChange={e => {
                              let newValue = Number(e.target.value);
                              let newPrice = newValue;
                              let newCurrency = 'UZS';
                              // For Customer3, store in their currency
                              if (selectedCustomer3 && selectedCustomer3.currency) {
                                newCurrency = selectedCustomer3.currency;
                                if (item.currency && item.currency !== selectedCustomer3.currency) {
                                  // Convert back to item's original currency for storage
                                  if (item.currency === 'USD' && selectedCustomer3.currency === 'UZS') {
                                    newPrice = +(newValue / exchangeRate).toFixed(2);
                                  } else if (item.currency === 'UZS' && selectedCustomer3.currency === 'USD') {
                                    newPrice = Math.round(newValue * exchangeRate);
                                  }
                                }
                              }
                              updateCustomer(current.id, {
                                cart: cart.map(ci => ci.id === item.id && (ci.batch_id || '') === (item.batch_id || '') ? { ...ci, price: newPrice, currency: newCurrency } : ci)
                              });
                            }}
                            onClick={e => e.stopPropagation()}
                          />
                          {item._usd !== undefined && (
                            <div style={{ fontSize: 11, color: '#888' }}>
                              USD: {item._usd.toFixed(2)}
                            </div>
                          )}
                        </td>
                        <td>
                          {(() => {
                            // Check if this product has multiple batches in cart (already split)
                            const productCartItems = cart.filter(ci => ci.id === item.id);
                            const hasMultipleBatches = productCartItems.length > 1;

                            // For FIFO products, check if we should disable editing after splitting
                            const product = products.find(p => p.id === item.id || p.productid === item.id);
                            const isFifoProduct = product && product.costing_method !== 'Specific';
                            const shouldDisableEdit = isFifoProduct && hasMultipleBatches;

                            if (shouldDisableEdit) {
                              // Show read-only quantity for split FIFO products
                              return (
                                <div className="form-control form-control-sm bg-light text-muted" style={{ border: 'none' }}>
                                  {item.qty}
                                </div>
                              );
                            }

                            // Calculate total available quantity for this product across all batches
                            const cacheKey = `${item.id}_${selectedStoreId}`;
                            const availableBatches = allFifoBatchesByProductId[cacheKey] || [];
                            const usedMap = getUsedQtyByBatchForProduct(item.id);
                            const totalAvailable = availableBatches.reduce((sum, batch) => {
                              const used = usedMap.get(batch.id) || 0;
                              const remaining = Number(batch.available_quantity ?? batch.quantity_remaining ?? 0) - Number(used);
                              return sum + Math.max(0, remaining);
                            }, 0);

                            // Add current cart quantity to available (since we're editing)
                            const currentCartQty = productCartItems.reduce((sum, ci) => sum + ci.qty, 0);
                            const maxAllowed = totalAvailable + currentCartQty;

                            return (
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={item._qtyInput !== undefined ? item._qtyInput : item.qty}
                                min={isFifoProduct ? 0.001 : 1}
                                step={isFifoProduct ? 0.001 : 1}
                                max={maxAllowed}
                                onChange={e => {
                                  e.stopPropagation();
                                  const val = sanitizeDecimalInput(e.target.value, 3);
                                  const numVal = parseFloat(val);

                                  // Prevent input greater than max available
                                  if (!isNaN(numVal) && numVal > maxAllowed) {
                                    return; // Don't update if exceeds max
                                  }

                                  // Store temporary input value without committing to qty yet
                                  updateCustomer(current.id, {
                                    cart: cart.map(ci => (
                                      ci.id === item.id && (ci.batch_id || '') === (item.batch_id || '')
                                        ? { ...ci, _qtyInput: val }
                                        : ci
                                    ))
                                  });
                                }}
                                onBlur={async e => {
                                  e.stopPropagation();
                                  const raw = sanitizeDecimalInput(e.target.value, 3);
                                  let newQty = parseFloat(raw);
                                  const minVal = isFifoProduct ? 0.001 : 1;
                                  if (isNaN(newQty) || newQty < minVal) newQty = minVal;
                                  if (newQty > maxAllowed) newQty = maxAllowed;
                                  if (!isFifoProduct) newQty = Math.round(newQty);

                                  const oldQty = item.qty;

                                  if (newQty !== oldQty && isFifoProduct) {
                                    // For FIFO products, manually allocate FIFO units without relying on current cart state
                                    const productId = item.id;
                                    const otherItems = cart.filter(ci => ci.id !== item.id);

                                    // Get available batches for this product
                                    const availableBatches = await ensureFifoBatchesCached(product);
                                    if (!availableBatches || availableBatches.length === 0) return;

                                    // Calculate used quantities from OTHER products only (excluding current product)
                                    const usedMapFromOthers = new Map();
                                    otherItems.forEach(ci => {
                                      if (ci.batch_id) {
                                        usedMapFromOthers.set(ci.batch_id, (usedMapFromOthers.get(ci.batch_id) || 0) + ci.qty);
                                      }
                                    });

                                    // Allocate the new quantity across batches
                                    const allocations = allocateUnitsAcrossBatches(availableBatches, usedMapFromOthers, newQty);
                                    if (!allocations.length) return;

                                    // Create new cart items from allocations
                                    const newCartItems = [];
                                    allocations.forEach(({ batch, qty }) => {
                                      const { priceUZS, priceUSD } = computeBatchPrices(batch, product);
                                      const cartItem = {
                                        ...product,
                                        id: productId,
                                        name: getProductName(product),
                                        batch_id: batch.id,
                                        qty,
                                        price: priceUZS
                                      };
                                      if (selectedCustomer3 && selectedCustomer3.currency === 'USD' && priceUSD) {
                                        cartItem.price_usd = priceUSD;
                                        cartItem.currency_source = 'USD';
                                      }
                                      newCartItems.push(cartItem);
                                    });

                                    // Update cart with other items + new allocations
                                    updateCustomer(current.id, { cart: [...otherItems, ...newCartItems] });
                                  } else {
                                    // For non-FIFO or no change, just update normally
                                    const qtyDifference = newQty - oldQty;

                                    if (qtyDifference !== 0) {
                                      // Commit qty and clear temp buffer
                                      updateCustomer(current.id, {
                                        cart: cart.map(ci => (
                                          ci.id === item.id && (ci.batch_id || '') === (item.batch_id || '')
                                            ? { ...ci, qty: newQty, _qtyInput: undefined }
                                            : ci
                                        ))
                                      });
                                    } else {
                                      // No actual change; just clear the temp buffer
                                      updateCustomer(current.id, {
                                        cart: cart.map(ci => (
                                          ci.id === item.id && (ci.batch_id || '') === (item.batch_id || '')
                                            ? { ...ci, _qtyInput: undefined }
                                            : ci
                                        ))
                                      });
                                    }
                                  }
                                }}
                                onKeyDown={e => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                    e.currentTarget.blur(); // trigger onBlur commit
                                  }
                                }}
                                onClick={e => e.stopPropagation()}
                              />
                            );
                          })()}
                        </td>
                        <td>
                          {(() => {
                            const prodForUnit = products.find(p => p.id === item.id || p.productid === item.id) || item;
                            return (prodForUnit && (prodForUnit.birlik_name || prodForUnit.birlik)) ? (prodForUnit.birlik_name || prodForUnit.birlik) : '-';
                          })()}
                        </td>
                        <td>{formatAmount(item.qty * item.price)} UZS</td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={e => {
                              e.stopPropagation();
                              updateCustomer(current.id, {
                                cart: cart.filter(ci => !(ci.id === item.id && (ci.batch_id || '') === (item.batch_id || '')))
                              });
                            }}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3 gap-2 text-center text-md-start">
            <div className="d-flex flex-column align-items-center align-items-md-start">
              <div className="form-check form-switch form-check-reverse mt-2 mt-md-0">
                <label className="form-check-label ms-2" htmlFor="firstPriceSwitch">
                  Ulgurchi narxga
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="firstPriceSwitch"
                  checked={isFirstPrice}
                  onChange={handleToggleFirstPrice}
                />
              </div>
            </div>
            <div className="d-flex flex-column align-items-center align-items-md-end w-100 w-md-auto">
              <div style={{ fontSize: Number(deliveryPrice) > 0 ? 18 : 28, fontWeight: 600, color: '#222' }}>
                <span style={{ fontFamily: 'Quantico, sans-serif', letterSpacing: '0.5px' }}>Jami:</span> {formatAmount(totalSum)} UZS
              </div>
              {Number(deliveryPrice) > 0 && (
                <div style={{ fontSize: 15, color: '#555', marginTop: 2 }}>
                  + {formatAmount(Number(deliveryPrice))} UZS (Yetkazib berish)
                  <br />
                  <span style={{ fontWeight: 600 }}>
                    Umumiy: {formatAmount(overal)} UZS
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="mb-3">
            <div className="row mt-3">
              <div className="col-md-1 mb-3 me-3" style={{ position: 'relative' }}>
                <label className="form-label">Qarzga</label>
                <div className="input-group">
                  <button
                    className="btn btn-outline-warning"
                    type="button"
                    onClick={() => {
                      fetchCustomer2Data();
                      setShowCustomer2SaleModal(true);
                    }}
                  >
                    📋
                  </button>
                </div>
                {customer2Search && filteredCustomer2s.length > 0 && !selectedCustomer2 && (
                  <div
                    className="list-group"
                    style={{
                      position: 'absolute',
                      zIndex: 10,
                      width: '100%',
                      maxHeight: 200,
                      overflowY: 'auto'
                    }}
                  >
                    {filteredCustomer2s.map(c => (
                      <button
                        type="button"
                        key={c.id}
                        className="list-group-item list-group-item-action"
                        onClick={() => {
                          setSelectedCustomer2(c);
                          setCustomer2Search('');
                        }}
                      >
                        <div><b>{c.name}</b></div>
                        <div style={{ fontSize: 13, color: '#888' }}>{c.phone}</div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="col-md-4" style={{ position: 'relative' }}>
                <label className="form-label">Mijoz</label>
                <div className="input-group">
                  <button
                    className="btn btn-outline-success"
                    type="button"
                    onClick={() => setShowCustomerModal(true)}
                    tabIndex={-1}
                  >
                    ➕
                  </button>
                  <input
                    className="form-control"
                    placeholder="Ism yoki telefon raqam..."
                    value={customerSearch}
                    onChange={e => setCustomerSearch(e.target.value)}
                    onFocus={() => fetchCustomer1Data()}
                    readOnly={!!selectedCustomer}
                  />
                  {selectedCustomer && (
                    <span className="input-group-text bg-success text-white" style={{ fontWeight: 'bold' }}>
                      {selectedCustomer.name} ({selectedCustomer.phone})
                    </span>
                  )}
                </div>
                {customerSearch && filteredCustomers.length > 0 && (
                  <div
                    className="list-group"
                    style={{
                      position: 'absolute',
                      zIndex: 10,
                      width: '100%',
                      maxHeight: 200,
                      overflowY: 'auto'
                    }}
                  >
                    {filteredCustomers.map(c => (
                      <button
                        type="button"
                        key={c.id}
                        className="list-group-item list-group-item-action"
                        onClick={() => {
                          setSelectedCustomer(c);
                          setCustomerSearch('');
                        }}
                      >
                        <div><b>{c.name}</b></div>
                        <div style={{ fontSize: 13, color: '#888' }}>{c.phone}</div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="col-md-4 mb-3" style={{ position: 'relative' }}>
                <label className="form-label">3-turi Mijoz</label>
                <div className="input-group">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setShowCustomer3Modal(true)}
                    tabIndex={-1}
                  >
                    ➕
                  </button>
                  <button
                    className="btn btn-outline-info"
                    type="button"
                    onClick={() => {
                      fetchCustomer3Data();
                      setShowCustomer3SalesModal(true);
                    }}
                  >
                    🕑
                  </button>
                  {selectedCustomer3 && (
                    <span className="input-group-text bg-info text-white" style={{ fontWeight: 'bold' }}>
                      {selectedCustomer3.name} ({selectedCustomer3.phone})
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-2 d-flex flex-column align-items-center">
                <label className="form-label">Yetkazish/O'rnatish </label>

                <div className="d-inline-flex align-items-center p-1 px-2 rounded-pill border bg-white shadow-sm" style={{ transition: 'all 0.3s' }}>
                  <div className="form-check form-switch mb-0 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={`delivery${current.id}`}
                      checked={current.delivery}
                      onChange={e => {
                        const checked = e.target.checked;
                        updateCustomer(current.id, { delivery: checked });
                        if (!checked) setDeliveryPrice('');
                      }}
                      style={{ cursor: 'pointer', width: '2.4em', height: '1.2em' }}
                    />
                  </div>
                  <FaTruck className={`ms-2 ${current.delivery ? 'text-primary' : 'text-muted'}`} style={{ fontSize: '1.1rem' }} title="Yetkazib berish" />

                  {current.delivery && (
                    <div className="ms-2 d-flex align-items-center border-start ps-2">
                      <input
                        type="text"
                        className="form-control form-control-sm border-0 bg-transparent shadow-none p-0"
                        placeholder="Narxi..."
                        value={deliveryPrice}
                        onChange={e => setDeliveryPrice(e.target.value.replace(/[^0-9]/g, ''))}
                        onFocus={e => e.target.select()}
                        style={{ width: '80px', fontWeight: '700', fontSize: '0.9rem' }}
                      />
                      <span className="text-muted ms-1 small fw-bold" style={{ fontSize: '0.75rem' }}>uzs</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row flex-nowrap g-2 align-items-end">
              <div className="col-6">
                <label className="form-label mb-1 small">To'lov turi</label>
                {current.paymentType === 'hybrid' ? (
                  <div className="d-flex align-items-center gap-1 flex-wrap">
                    <span className="badge bg-primary p-2 small">Aralash to'lov</span>
                    <div className="d-flex gap-1">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => setShowMultiplePaymentModal(true)}
                        className="p-1"
                      >
                        <FaEdit size={14} />
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => {
                          updateCustomer(current.id, { paymentType: '' });
                          setHybridPayments([]);
                        }}
                        className="p-1"
                      >
                        <FaTrash size={14} />
                      </Button>
                    </div>
                  </div>
                ) : (
                  <PaymentMethodSelector
                    value={current.paymentType}
                    onChange={handlePaymentTypeChange}
                    onSplitClick={() => {
                      updateCustomer(current.id, { paymentType: 'hybrid' });
                      setShowMultiplePaymentModal(true);
                    }}
                    showSplit={true}
                  />
                )}
              </div>
              <div className="col-6">
                <button
                  className="btn w-100"
                  style={{
                    background: 'linear-gradient(90deg,rgba(2, 81, 12, 1) 0%, rgba(7, 143, 23, 1) 55%, rgba(2, 97, 7, 1) 100%)',
                    color: 'white',
                    fontSize: 'min(20px, 4vw)',
                    border: 'none',
                    borderRadius: 12,
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 4px',
                    lineHeight: '1.2'
                  }}
                  onClick={() => handleSale(false)}
                  disabled={!cart.length}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center' }}>
                    <span>Sotish:</span>
                    <b>{formatAmount(totalSum)}</b>
                  </div>
                </button>
              </div>
            </div>


          </div>
        </div>
      </div>
      {/* Batch Selection Modal (for Specific Identification) */}
      <Modal show={showBatchModal} onHide={() => {
        setShowBatchModal(false);
        setModalError('');
        setLoadingModal(false);
        setSelectedBatch(null);
        setBatchQty(1);
        setSelectedBatches([]); // Reset multiple selection
        setBatchProduct(null);
        setFifoBatches([]);
        setSpecificBarcodesByBatch({});
        setSpecificBarcodeSearch('');
      }} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === 'FIFO' ? 'FIFO Partiyalar' : modalType === 'Specific' ? 'Secific/ Barcodlar' : 'Partiya/batch tanlash'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && (
            <div className="alert alert-danger">
              <strong>Xatolik:</strong> {modalError}
              <button
                type="button"
                className="btn-close float-end"
                onClick={() => setModalError('')}
                aria-label="Close"
              ></button>
            </div>
          )}
          {/* Barcode search input for all batches (Specific type) */}
          {modalType === 'Specific' && (
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Barcode qidirish..."
              value={specificBarcodeSearch}
              onChange={e => setSpecificBarcodeSearch(e.target.value)}
            />
          )}
          {loadingModal ? (
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Yuklanmoqda...</span>
              </div>
              <div className="mt-2">Partiyalar yuklanmoqda...</div>
            </div>
          ) : (
            modalType === 'FIFO' ? (
              fifoBatches.length === 0 ? (
                <div className="text-center p-4">
                  <div className="text-muted">
                    <i className="fas fa-exclamation-triangle mb-2" style={{ fontSize: '2rem' }}></i>
                    <p>Bu mahsulot uchun mavjud partiyalar topilmadi.</p>
                    <p className="small">Barcha partiyalar tugagan yoki miqdori 0 ga teng.</p>
                  </div>
                </div>
              ) : (
                <div className="table-responsive" style={{ overflowX: 'auto', marginLeft: -8, marginRight: -8 }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Yaratilgan</th>
                        <th>Tan narx</th>
                        <th>Mavjud miqdor</th>
                        <th>Sotish narxi</th>
                        <th>Ulgurchi narx</th>
                        <th>Joy/ombor</th>
                        <th>Tanlash</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fifoBatches.map(batch => (
                        <tr key={batch.id}>
                          <td>{formatDate(batch.created_at)}</td>
                          <td>{batch.costperunit}</td>
                          <td>{Number(batch.available_quantity ?? batch.quantity_remaining ?? 0)}</td>
                          <td>{batch.sellingprice}</td>
                          <td>{batch.first_price || '-'}</td>
                          <td>{batch.store_name || batch.storeid || '-'}</td>
                          <td>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="batchSelect"
                                id={`batchRadio${batch.id}`}
                                checked={selectedBatch && selectedBatch.id === batch.id}
                                onChange={() => {
                                  setSelectedBatch(batch);
                                  setBatchQty(1);
                                }}
                              />
                              <label className="form-check-label" htmlFor={`batchRadio${batch.id}`}></label>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            ) : modalType === 'Specific' ? (
              Object.keys(specificBarcodesByBatch).length === 0 ? (
                <div className="text-center p-4">
                  <div className="text-muted">
                    <i className="fas fa-exclamation-triangle mb-2" style={{ fontSize: '2rem' }}></i>
                    <p>Bu mahsulot uchun mavjud partiyalar yoki shtrix-kodlar topilmadi.</p>
                    <p className="small">Barcha partiyalar tugagan yoki mavjud emas.</p>
                  </div>
                </div>
              ) : (
                <div>
                  {Object.values(specificBarcodesByBatch).map(({ batch, barcodes }) => {
                    const filteredBarcodes = barcodes.filter(bc => bc.toLowerCase().includes(specificBarcodeSearch.toLowerCase()));
                    if (filteredBarcodes.length === 0) return null;
                    return (
                      <div key={batch.id} className="mb-4">
                        <div className="fw-bold mb-1">
                          <span style={{ color: '#1976d2' }}>Yaratilgan: {formatDate(batch.created_at)}</span>
                          <span style={{ color: '#888', marginLeft: 16 }}>BatchID: {batch.BatchID || batch.id}</span>
                        </div>
                        <div className="table-responsive" style={{ overflowX: 'auto', marginLeft: -8, marginRight: -8 }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Barcode</th>
                                <th>Tan narx</th>
                                <th>Sotish narxi</th>
                                <th>Ulgurchi narx</th>
                                <th>Joy/Ombor</th>
                                <th>Tanlash</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredBarcodes.length === 0 ? (
                                <tr><td colSpan={6}>Barcode yo'q</td></tr>
                              ) : filteredBarcodes.map(bc => (
                                <tr key={bc}>
                                  <td>{bc}</td>
                                  <td>{batch.costperunit}</td>
                                  <td>{batch.sellingprice}</td>
                                  <td>{batch.first_price || '-'}</td>
                                  <td>{batch.store_name || '-'}</td>
                                  <td>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`barcodeCheckbox${batch.id}_${bc}`}
                                        checked={selectedBatches.some(selected => selected.batch.id === batch.id && selected.barcode === bc)}
                                        onChange={(e) => {
                                          const isChecked = e.target.checked;
                                          if (isChecked) {
                                            // Add to selection
                                            setSelectedBatches(prev => [...prev, { batch, barcode: bc }]);
                                          } else {
                                            // Remove from selection
                                            setSelectedBatches(prev => prev.filter(selected =>
                                              !(selected.batch.id === batch.id && selected.barcode === bc)
                                            ));
                                          }
                                        }}
                                      />
                                      <label className="form-check-label" htmlFor={`barcodeCheckbox${batch.id}_${bc}`}></label>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            ) : (
              <div>Batafsil batch topilmadi.</div>
            )
          )}
          {modalType === 'FIFO' && selectedBatch && (
            <div className="mt-2">
              <label>Miqdor:</label>
              <input
                type="number"
                className="form-control"
                min={1}
                max={(() => {
                  const productId = batchProduct?.productid;
                  const usedInCartForBatch = cart
                    .filter(ci => ci.id === productId && ci.batch_id === selectedBatch.id)
                    .reduce((sum, ci) => sum + Number(ci.qty || 0), 0);
                  const sellableInBatch = Math.max(
                    0,
                    Number(selectedBatch.available_quantity ?? selectedBatch.quantity_remaining ?? 0) - usedInCartForBatch
                  );
                  return sellableInBatch;
                })()}
                value={batchQty}
                onChange={e => {
                  const productId = batchProduct?.productid;
                  const usedInCartForBatch = cart
                    .filter(ci => ci.id === productId && ci.batch_id === selectedBatch.id)
                    .reduce((sum, ci) => sum + Number(ci.qty || 0), 0);
                  const sellableInBatch = Math.max(
                    0,
                    Number(selectedBatch.available_quantity ?? selectedBatch.quantity_remaining ?? 0) - usedInCartForBatch
                  );
                  setBatchQty(Math.max(1, Math.min(sellableInBatch, Number(e.target.value))));
                }}
              />
            </div>
          )}

          {/* Selected batches summary for Specific products */}
          {modalType === 'Specific' && selectedBatches.length > 0 && (
            <div className="mt-3 p-3 bg-light rounded">
              <h6>Tanlangan barcodelar ({selectedBatches.length}):</h6>
              <div className="row">
                {selectedBatches.map((selected, index) => (
                  <div key={index} className="col-md-6 mb-1">
                    <span className="badge bg-primary me-1">{selected.barcode}</span>
                    <small className="text-muted">
                      {selected.batch.sellingprice} {selected.batch.currency}
                    </small>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBatchModal(false)}>
            Bekor qilish
          </Button>
          {modalError && (
            <Button
              variant="warning"
              onClick={() => {
                setModalError('');
                setLoadingModal(true);
                if (batchProduct) {
                  openBatchModal(batchProduct);
                }
              }}
            >
              Qayta urinish
            </Button>
          )}
          <Button
            variant="primary"
            onClick={handleBatchAdd}
            disabled={modalType === 'Specific' ? selectedBatches.length === 0 : !selectedBatch}
          >
            {modalType === 'Specific' ? `Tanlash (${selectedBatches.length})` : 'Tanlash'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Customer3SalesHistoryModal
        show={showCustomer3SalesModal}
        onHide={() => { setShowCustomer3SalesModal(false); setSelectedCustomer3(null); }}
        selectedCustomer3={selectedCustomer3}
        allCustomer3s={allCustomer3s}
        onCustomerSelect={setSelectedCustomer3}
        currentSale={cart}
        onConfirmSale={handleConfirmSale}
        deliveryPrice={deliveryPrice}
        setDeliveryPrice={setDeliveryPrice}
        onUpdateCartItem={(idx, changes) => {
          const item = cart[idx];
          const oldQty = item.qty || 0;
          const newQty = changes.qty !== undefined ? changes.qty : oldQty;
          const qtyDiff = newQty - oldQty;

          updateCustomer(current.id, {
            cart: cart.map((item, i) => i === idx ? { ...item, ...changes } : item)
          });

          // Update batch quantity when quantity changes
          if (qtyDiff !== 0 && item && item.batch_id) {
            // If batch quantity not cached, fetch it first
            if (batchQuantities[item.batch_id] === undefined) {
              fetch(`/api/purchases/batch/${item.batch_id}`, {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              })
                .then(res => res.ok ? res.json() : null)
                .then(batch => {
                  if (batch) {
                    const currentBatchQty = Number(batch.quantity_remaining || 0);
                    const updatedBatchQty = currentBatchQty - qtyDiff;
                    setBatchQuantities(prev => ({
                      ...prev,
                      [item.batch_id]: Math.max(0, updatedBatchQty)
                    }));
                  }
                })
                .catch(e => console.error('Error fetching batch quantity:', e));
            } else {
              // Update batch quantity directly
              setBatchQuantities(prev => {
                const currentBatchQty = prev[item.batch_id] || 0;
                // If decrementing (qtyDiff < 0), add back to batch quantity
                // If incrementing (qtyDiff > 0), subtract from batch quantity
                const updatedBatchQty = currentBatchQty - qtyDiff;
                return {
                  ...prev,
                  [item.batch_id]: Math.max(0, updatedBatchQty)
                };
              });
            }

            // Update product quantity (sum of all batch quantities for this product)
            const cacheKey = `${item.id}_${selectedStoreId}`;
            // Recalculate product quantity from all batches
            (async () => {
              try {
                const res = await fetch(`/api/products/${item.id}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`, {
                  headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                  }
                });

                if (res.ok) {
                  const batches = await res.json();
                  const product = products.find(p => p.productid === item.id);

                  let totalQty = 0;
                  batches.forEach(batch => {
                    const batchId = batch.id;
                    const batchQty = batchQuantities[batchId] !== undefined
                      ? batchQuantities[batchId]
                      : Number(batch.available_quantity ?? batch.quantity_remaining ?? 0);

                    if (product && product.costing_method === 'Specific') {
                      if ((batch.status || '').toLowerCase() === 'available' && batchQty > 0) {
                        totalQty += batchQty;
                      }
                    } else {
                      if (batchQty > 0) {
                        totalQty += batchQty;
                      }
                    }
                  });

                  setProductQuantities(prev => ({
                    ...prev,
                    [cacheKey]: totalQty
                  }));
                }
              } catch (e) {
                console.error('Error updating product quantity:', e);
              }
            })();
          }
        }}
        onRemoveCartItem={idx => {
          const removedItem = cart[idx];
          updateCustomer(current.id, {
            cart: cart.filter((_, i) => i !== idx)
          });

          // Restore batch quantity when item is removed from cart
          if (removedItem && removedItem.batch_id) {
            const quantityToRestore = removedItem.qty || 0;
            setBatchQuantities(prev => ({
              ...prev,
              [removedItem.batch_id]: (prev[removedItem.batch_id] || 0) + quantityToRestore
            }));

            // Update product quantity (sum of all batch quantities for this product)
            const cacheKey = `${removedItem.id}_${selectedStoreId}`;
            fetch(`/api/products/${removedItem.id}/available-batches?storeId=${encodeURIComponent(String(selectedStoreId || ''))}${isBookingSale ? bookingExcludeQuery : ''}`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            })
              .then(res => res.ok ? res.json() : [])
              .then(batches => {
                const product = products.find(p => p.productid === removedItem.id);
                let totalQty = 0;
                batches.forEach(batch => {
                  const batchId = batch.id;
                  const batchQty = batchQuantities[batchId] !== undefined
                    ? batchQuantities[batchId]
                    : Number(batch.available_quantity ?? batch.quantity_remaining ?? 0);

                  if (product && product.costing_method === 'Specific') {
                    if ((batch.status || '').toLowerCase() === 'available' && batchQty > 0) {
                      totalQty += batchQty;
                    }
                  } else {
                    if (batchQty > 0) {
                      totalQty += batchQty;
                    }
                  }
                });

                setProductQuantities(prev => ({
                  ...prev,
                  [cacheKey]: totalQty
                }));
              })
              .catch(e => console.error('Error updating product quantity on remove:', e));
          }
        }}
        showFirstPriceSwitch={true}
        isFirstPrice={isFirstPrice}
        onToggleFirstPrice={handleToggleFirstPrice}
        loading={isSubmitting}
      />
      <Customer2SaleModal
        show={showCustomer2SaleModal}
        onHide={() => setShowCustomer2SaleModal(false)}
        cart={cart}
        customer2={selectedCustomer2}
        deliveryPrice={deliveryPrice}
        loading={isSubmitting}
      />
      <SaleConfirmationModal
        show={showSaleConfirmModal}
        onHide={() => setShowSaleConfirmModal(false)}
        onConfirm={() => handleConfirmSale(null, false)}
        onConfirmPrint={() => handleConfirmSale(null, true)}
        cart={cart}
        customer={selectedCustomer || selectedCustomer2 || selectedCustomer3}
        customerType={selectedCustomer3 ? 'customer3' : selectedCustomer2 ? 'customer2' : 'customer1'}
        deliveryPrice={deliveryPrice}
        paymentType={current.paymentType}
        hybridPayments={hybridPayments}
        business={stores.find(s => (s.id || s.ID) === selectedStoreId) ? {
          name: stores.find(s => (s.id || s.ID) === selectedStoreId).name || stores.find(s => (s.id || s.ID) === selectedStoreId).store_name,
          address: stores.find(s => (s.id || s.ID) === selectedStoreId).address || stores.find(s => (s.id || s.ID) === selectedStoreId).location,
          phone: stores.find(s => (s.id || s.ID) === selectedStoreId).phone || stores.find(s => (s.id || s.ID) === selectedStoreId).tel
        } : null}
        loading={isSubmitting}
        onBookingSuccess={handleBookingSuccess}
      />
      <MultiplePaymentModal
        show={showMultiplePaymentModal}
        onHide={() => setShowMultiplePaymentModal(false)}
        onConfirm={payments => {
          setHybridPayments(payments);
          setShowMultiplePaymentModal(false);
        }}
        totalAmount={overal}
        currency="UZS"
      />
    </div>
  );
};

export default Kassa;
